//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.5.0.0 (NJsonSchema v11.4.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class Client {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    actionItemPOST(body: ActionItemDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/ActionItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActionItemPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActionItemPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processActionItemPOST(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : null as any;
    
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    actionItemPUT(body: ActionItemDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ActionItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActionItemPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActionItemPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActionItemPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    actionItemDELETE(id: number): Observable<number> {
        let url_ = this.baseUrl + "/api/ActionItem/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActionItemDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActionItemDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processActionItemDELETE(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    actionItemGET(id: number): Observable<ActionItemDto> {
        let url_ = this.baseUrl + "/api/ActionItem/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActionItemGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActionItemGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActionItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActionItemDto>;
        }));
    }

    protected processActionItemGET(response: HttpResponseBase): Observable<ActionItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActionItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    paged(pageNumber: number | undefined, pageSize: number | undefined): Observable<ActionItemDtoPagedResult> {
        let url_ = this.baseUrl + "/api/ActionItem/paged?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActionItemDtoPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActionItemDtoPagedResult>;
        }));
    }

    protected processPaged(response: HttpResponseBase): Observable<ActionItemDtoPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActionItemDtoPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    status(id: number, body: ChangeActionitemStatusRequestDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ActionItem/{id}/status";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    reactivate(id: number, body: ReactivateActionItemRequestDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ActionItem/{id}/reactivate";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReactivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReactivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReactivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    approvalFlowPOST(body: ApprovalFlowDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/ApprovalFlow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApprovalFlowPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApprovalFlowPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processApprovalFlowPOST(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : null as any;
    
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    byGeneralTab(generalTabId: string): Observable<ApprovalFlowDto> {
        let url_ = this.baseUrl + "/api/ApprovalFlow/by-general-tab/{generalTabId}";
        if (generalTabId === undefined || generalTabId === null)
            throw new globalThis.Error("The parameter 'generalTabId' must be defined.");
        url_ = url_.replace("{generalTabId}", encodeURIComponent("" + generalTabId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processByGeneralTab(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processByGeneralTab(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApprovalFlowDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApprovalFlowDto>;
        }));
    }

    protected processByGeneralTab(response: HttpResponseBase): Observable<ApprovalFlowDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApprovalFlowDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    state(generalTabId: string, body: ChangeApprovalStateDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ApprovalFlow/{generalTabId}/state";
        if (generalTabId === undefined || generalTabId === null)
            throw new globalThis.Error("The parameter 'generalTabId' must be defined.");
        url_ = url_.replace("{generalTabId}", encodeURIComponent("" + generalTabId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processState(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    reactivate2(generalTabId: string, body: OutOfServiceActionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ApprovalFlow/{generalTabId}/reactivate";
        if (generalTabId === undefined || generalTabId === null)
            throw new globalThis.Error("The parameter 'generalTabId' must be defined.");
        url_ = url_.replace("{generalTabId}", encodeURIComponent("" + generalTabId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReactivate2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReactivate2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReactivate2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    cancel(generalTabId: string, body: OutOfServiceActionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ApprovalFlow/{generalTabId}/out-of-service/cancel";
        if (generalTabId === undefined || generalTabId === null)
            throw new globalThis.Error("The parameter 'generalTabId' must be defined.");
        url_ = url_.replace("{generalTabId}", encodeURIComponent("" + generalTabId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    steps(generalTabId: string): Observable<ApprovalFlowStepDto[]> {
        let url_ = this.baseUrl + "/api/ApprovalFlow/{generalTabId}/steps";
        if (generalTabId === undefined || generalTabId === null)
            throw new globalThis.Error("The parameter 'generalTabId' must be defined.");
        url_ = url_.replace("{generalTabId}", encodeURIComponent("" + generalTabId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSteps(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSteps(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApprovalFlowStepDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApprovalFlowStepDto[]>;
        }));
    }

    protected processSteps(response: HttpResponseBase): Observable<ApprovalFlowStepDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApprovalFlowStepDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    fdmEvents(generalTabId: string): Observable<FdmEventDto[]> {
        let url_ = this.baseUrl + "/api/ApprovalFlow/{generalTabId}/fdm-events";
        if (generalTabId === undefined || generalTabId === null)
            throw new globalThis.Error("The parameter 'generalTabId' must be defined.");
        url_ = url_.replace("{generalTabId}", encodeURIComponent("" + generalTabId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFdmEvents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFdmEvents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FdmEventDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FdmEventDto[]>;
        }));
    }

    protected processFdmEvents(response: HttpResponseBase): Observable<FdmEventDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FdmEventDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    approvalFlowPUT(id: string, body: ApprovalFlowDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ApprovalFlow/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApprovalFlowPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApprovalFlowPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processApprovalFlowPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    additionalEndorser(generalTabId: string, body: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ApprovalFlow/{generalTabId}/additional-endorser";
        if (generalTabId === undefined || generalTabId === null)
            throw new globalThis.Error("The parameter 'generalTabId' must be defined.");
        url_ = url_.replace("{generalTabId}", encodeURIComponent("" + generalTabId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdditionalEndorser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdditionalEndorser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAdditionalEndorser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    byGeneralTabAll(generalTabId: string): Observable<AuditLogEntryDto[]> {
        let url_ = this.baseUrl + "/api/AuditLogs/by-general-tab/{generalTabId}";
        if (generalTabId === undefined || generalTabId === null)
            throw new globalThis.Error("The parameter 'generalTabId' must be defined.");
        url_ = url_.replace("{generalTabId}", encodeURIComponent("" + generalTabId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processByGeneralTabAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processByGeneralTabAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditLogEntryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditLogEntryDto[]>;
        }));
    }

    protected processByGeneralTabAll(response: HttpResponseBase): Observable<AuditLogEntryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AuditLogEntryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    damageMechanismGET(id: string): Observable<DamageMechanismDto> {
        let url_ = this.baseUrl + "/api/DamageMechanism/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDamageMechanismGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDamageMechanismGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DamageMechanismDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DamageMechanismDto>;
        }));
    }

    protected processDamageMechanismGET(response: HttpResponseBase): Observable<DamageMechanismDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DamageMechanismDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    damageMechanismPUT(id: string, body: DamageMechanismDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/DamageMechanism/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDamageMechanismPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDamageMechanismPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDamageMechanismPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    damageMechanismDELETE(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/DamageMechanism/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDamageMechanismDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDamageMechanismDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDamageMechanismDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    damageMechanismAll(): Observable<DamageMechanismDto[]> {
        let url_ = this.baseUrl + "/api/DamageMechanism";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDamageMechanismAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDamageMechanismAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DamageMechanismDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DamageMechanismDto[]>;
        }));
    }

    protected processDamageMechanismAll(response: HttpResponseBase): Observable<DamageMechanismDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DamageMechanismDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    damageMechanismPOST(body: DamageMechanismDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/DamageMechanism";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDamageMechanismPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDamageMechanismPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDamageMechanismPOST(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : null as any;
    
            return _observableOf(result201);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param title (optional) 
     * @return OK
     */
    byTitle(title: string | undefined): Observable<DamageMechanismDto[]> {
        let url_ = this.baseUrl + "/api/DamageMechanism/by-title?";
        if (title === null)
            throw new globalThis.Error("The parameter 'title' cannot be null.");
        else if (title !== undefined)
            url_ += "title=" + encodeURIComponent("" + title) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processByTitle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processByTitle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DamageMechanismDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DamageMechanismDto[]>;
        }));
    }

    protected processByTitle(response: HttpResponseBase): Observable<DamageMechanismDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DamageMechanismDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    activate(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/DamageMechanism/activate/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    deactivate(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/DamageMechanism/deactivate/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeactivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param includeInactive (optional) 
     * @return OK
     */
    distributionListAll(includeInactive: boolean | undefined): Observable<DistributionList[]> {
        let url_ = this.baseUrl + "/api/DistributionList?";
        if (includeInactive === null)
            throw new globalThis.Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDistributionListAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDistributionListAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DistributionList[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DistributionList[]>;
        }));
    }

    protected processDistributionListAll(response: HttpResponseBase): Observable<DistributionList[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DistributionList.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    distributionListPOST(body: CreateDistributionListDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/DistributionList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDistributionListPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDistributionListPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDistributionListPOST(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : null as any;
    
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    distributionListGET(id: number): Observable<DistributionList> {
        let url_ = this.baseUrl + "/api/DistributionList/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDistributionListGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDistributionListGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DistributionList>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DistributionList>;
        }));
    }

    protected processDistributionListGET(response: HttpResponseBase): Observable<DistributionList> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DistributionList.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    distributionListPUT(id: number, body: UpdateDistributionListDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/DistributionList/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDistributionListPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDistributionListPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDistributionListPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    distributionListDELETE(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/DistributionList/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDistributionListDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDistributionListDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDistributionListDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    deactivate2(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/DistributionList/{id}/deactivate";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivate2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivate2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeactivate2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    activate2(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/DistributionList/{id}/activate";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivate2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivate2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivate2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    byUnit(unit: string): Observable<DistributionList> {
        let url_ = this.baseUrl + "/api/DistributionList/by-unit/{unit}";
        if (unit === undefined || unit === null)
            throw new globalThis.Error("The parameter 'unit' must be defined.");
        url_ = url_.replace("{unit}", encodeURIComponent("" + unit));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processByUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processByUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DistributionList>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DistributionList>;
        }));
    }

    protected processByUnit(response: HttpResponseBase): Observable<DistributionList> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DistributionList.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    titles(): Observable<DistributionListTitleDto[]> {
        let url_ = this.baseUrl + "/api/DistributionList/titles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTitles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTitles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DistributionListTitleDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DistributionListTitleDto[]>;
        }));
    }

    protected processTitles(response: HttpResponseBase): Observable<DistributionListTitleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DistributionListTitleDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    byGeneralTab2(generalTabId: string): Observable<EquipmentTabDto> {
        let url_ = this.baseUrl + "/api/EquipmentTab/by-general-tab/{generalTabId}";
        if (generalTabId === undefined || generalTabId === null)
            throw new globalThis.Error("The parameter 'generalTabId' must be defined.");
        url_ = url_.replace("{generalTabId}", encodeURIComponent("" + generalTabId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processByGeneralTab2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processByGeneralTab2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EquipmentTabDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EquipmentTabDto>;
        }));
    }

    protected processByGeneralTab2(response: HttpResponseBase): Observable<EquipmentTabDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EquipmentTabDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param cursor (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    e1(cursor: string | undefined, pageSize: number | undefined): Observable<E1EquipmentDtoInfiniteScrollResult> {
        let url_ = this.baseUrl + "/api/EquipmentTab/e1?";
        if (cursor === null)
            throw new globalThis.Error("The parameter 'cursor' cannot be null.");
        else if (cursor !== undefined)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processE1(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processE1(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<E1EquipmentDtoInfiniteScrollResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<E1EquipmentDtoInfiniteScrollResult>;
        }));
    }

    protected processE1(response: HttpResponseBase): Observable<E1EquipmentDtoInfiniteScrollResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = E1EquipmentDtoInfiniteScrollResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    unitCodes(): Observable<string[]> {
        let url_ = this.baseUrl + "/unit-codes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnitCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnitCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processUnitCodes(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param term (optional) 
     * @param maxResults (optional) 
     * @return OK
     */
    searchAll(term: string | undefined, maxResults: number | undefined): Observable<E1EquipmentDto[]> {
        let url_ = this.baseUrl + "/api/EquipmentTab/e1/search?";
        if (term === null)
            throw new globalThis.Error("The parameter 'term' cannot be null.");
        else if (term !== undefined)
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        if (maxResults === null)
            throw new globalThis.Error("The parameter 'maxResults' cannot be null.");
        else if (maxResults !== undefined)
            url_ += "maxResults=" + encodeURIComponent("" + maxResults) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<E1EquipmentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<E1EquipmentDto[]>;
        }));
    }

    protected processSearchAll(response: HttpResponseBase): Observable<E1EquipmentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(E1EquipmentDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param cursor (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    predix(cursor: string | undefined, pageSize: number | undefined): Observable<GePredixEquipmentDtoInfiniteScrollResult> {
        let url_ = this.baseUrl + "/api/EquipmentTab/predix?";
        if (cursor === null)
            throw new globalThis.Error("The parameter 'cursor' cannot be null.");
        else if (cursor !== undefined)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPredix(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPredix(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GePredixEquipmentDtoInfiniteScrollResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GePredixEquipmentDtoInfiniteScrollResult>;
        }));
    }

    protected processPredix(response: HttpResponseBase): Observable<GePredixEquipmentDtoInfiniteScrollResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GePredixEquipmentDtoInfiniteScrollResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param term (optional) 
     * @param maxResults (optional) 
     * @return OK
     */
    searchAll2(term: string | undefined, maxResults: number | undefined): Observable<GePredixEquipmentDto[]> {
        let url_ = this.baseUrl + "/api/EquipmentTab/predix/search?";
        if (term === null)
            throw new globalThis.Error("The parameter 'term' cannot be null.");
        else if (term !== undefined)
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        if (maxResults === null)
            throw new globalThis.Error("The parameter 'maxResults' cannot be null.");
        else if (maxResults !== undefined)
            url_ += "maxResults=" + encodeURIComponent("" + maxResults) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchAll2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchAll2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GePredixEquipmentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GePredixEquipmentDto[]>;
        }));
    }

    protected processSearchAll2(response: HttpResponseBase): Observable<GePredixEquipmentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GePredixEquipmentDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tagNumber (optional) 
     * @param equipmentSource (optional) 
     * @return OK
     */
    searchByTagFromSynapse(tagNumber: string | undefined, equipmentSource: EquipmentSource | undefined): Observable<EquipmentByTagResultDto[]> {
        let url_ = this.baseUrl + "/api/EquipmentTab/search-by-tag-from-synapse?";
        if (tagNumber === null)
            throw new globalThis.Error("The parameter 'tagNumber' cannot be null.");
        else if (tagNumber !== undefined)
            url_ += "TagNumber=" + encodeURIComponent("" + tagNumber) + "&";
        if (equipmentSource === null)
            throw new globalThis.Error("The parameter 'equipmentSource' cannot be null.");
        else if (equipmentSource !== undefined)
            url_ += "EquipmentSource=" + encodeURIComponent("" + equipmentSource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchByTagFromSynapse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchByTagFromSynapse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EquipmentByTagResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EquipmentByTagResultDto[]>;
        }));
    }

    protected processSearchByTagFromSynapse(response: HttpResponseBase): Observable<EquipmentByTagResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EquipmentByTagResultDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    equipmentTabPOST(body: EquipmentTabDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/EquipmentTab";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEquipmentTabPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEquipmentTabPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processEquipmentTabPOST(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    equipmentTabPUT(id: number, body: EquipmentTabDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/EquipmentTab/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEquipmentTabPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEquipmentTabPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEquipmentTabPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    importFromSynapse(body: ImportSynapseEquipmentsRequest | undefined): Observable<any> {
        let url_ = this.baseUrl + "/api/EquipmentTab/import-from-synapse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportFromSynapse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportFromSynapse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processImportFromSynapse(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    facilityOwnerPOST(body: FacilityOwnerDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/FacilityOwner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFacilityOwnerPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFacilityOwnerPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processFacilityOwnerPOST(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : null as any;
    
            return _observableOf(result201);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    facilityOwnerAll(): Observable<FacilityOwnerDto[]> {
        let url_ = this.baseUrl + "/api/FacilityOwner";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFacilityOwnerAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFacilityOwnerAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FacilityOwnerDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FacilityOwnerDto[]>;
        }));
    }

    protected processFacilityOwnerAll(response: HttpResponseBase): Observable<FacilityOwnerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FacilityOwnerDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    facilityOwnerDELETE(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/FacilityOwner/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFacilityOwnerDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFacilityOwnerDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFacilityOwnerDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    facilityOwnerPUT(id: string, body: FacilityOwnerDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/FacilityOwner/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFacilityOwnerPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFacilityOwnerPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFacilityOwnerPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    facilityOwnerGET(id: string): Observable<FacilityOwnerDto> {
        let url_ = this.baseUrl + "/api/FacilityOwner/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFacilityOwnerGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFacilityOwnerGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FacilityOwnerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FacilityOwnerDto>;
        }));
    }

    protected processFacilityOwnerGET(response: HttpResponseBase): Observable<FacilityOwnerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FacilityOwnerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    activate3(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/FacilityOwner/activate/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivate3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivate3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivate3(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    deactivate3(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/FacilityOwner/deactivate/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivate3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivate3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeactivate3(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    displayNames(): Observable<FacilityOptionDto[]> {
        let url_ = this.baseUrl + "/api/FacilityOwner/facilities/display-names";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisplayNames(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisplayNames(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FacilityOptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FacilityOptionDto[]>;
        }));
    }

    protected processDisplayNames(response: HttpResponseBase): Observable<FacilityOptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FacilityOptionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    findingDescriptionTabPOST(body: FindingDescriptionTabDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/FindingDescriptionTab";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindingDescriptionTabPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindingDescriptionTabPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processFindingDescriptionTabPOST(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : null as any;
    
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    findingDescriptionTabPUT(id: number, body: FindingDescriptionTabDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/FindingDescriptionTab/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindingDescriptionTabPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindingDescriptionTabPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFindingDescriptionTabPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    byGeneralTab3(generalTabId: string): Observable<FindingDescriptionTabDto> {
        let url_ = this.baseUrl + "/api/FindingDescriptionTab/by-general-tab/{generalTabId}";
        if (generalTabId === undefined || generalTabId === null)
            throw new globalThis.Error("The parameter 'generalTabId' must be defined.");
        url_ = url_.replace("{generalTabId}", encodeURIComponent("" + generalTabId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processByGeneralTab3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processByGeneralTab3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FindingDescriptionTabDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FindingDescriptionTabDto>;
        }));
    }

    protected processByGeneralTab3(response: HttpResponseBase): Observable<FindingDescriptionTabDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FindingDescriptionTabDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param reportType (optional) 
     * @param search (optional) 
     * @param statuses (optional) 
     * @param statusFilterMode (optional) 
     * @param sortBy (optional) 
     * @param sortDirection (optional) 
     * @param columnFilters (optional) 
     * @return OK
     */
    generalTabGET(pageNumber: number | undefined, pageSize: number | undefined, reportType: ReportType | undefined, search: string | undefined, statuses: ApprovalState[] | undefined, statusFilterMode: StatusFilterMode | undefined, sortBy: GeneralTabSortField | undefined, sortDirection: SortDirection | undefined, columnFilters: ColumnFilter[] | undefined): Observable<GeneralTabListItemDtoPagedResult> {
        let url_ = this.baseUrl + "/api/GeneralTab?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (reportType === null)
            throw new globalThis.Error("The parameter 'reportType' cannot be null.");
        else if (reportType !== undefined)
            url_ += "ReportType=" + encodeURIComponent("" + reportType) + "&";
        if (search === null)
            throw new globalThis.Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (statuses === null)
            throw new globalThis.Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses && statuses.forEach(item => { url_ += "Statuses=" + encodeURIComponent("" + item) + "&"; });
        if (statusFilterMode === null)
            throw new globalThis.Error("The parameter 'statusFilterMode' cannot be null.");
        else if (statusFilterMode !== undefined)
            url_ += "StatusFilterMode=" + encodeURIComponent("" + statusFilterMode) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (columnFilters === null)
            throw new globalThis.Error("The parameter 'columnFilters' cannot be null.");
        else if (columnFilters !== undefined)
            columnFilters && columnFilters.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "ColumnFilters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeneralTabGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeneralTabGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralTabListItemDtoPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralTabListItemDtoPagedResult>;
        }));
    }

    protected processGeneralTabGET(response: HttpResponseBase): Observable<GeneralTabListItemDtoPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralTabListItemDtoPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    generalTabPOST(body: GeneralTabDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/GeneralTab";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeneralTabPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeneralTabPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGeneralTabPOST(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    search(body: GeneralTabSearchRequest | undefined): Observable<GeneralTabListItemDtoPagedResult> {
        let url_ = this.baseUrl + "/api/GeneralTab/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralTabListItemDtoPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralTabListItemDtoPagedResult>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<GeneralTabListItemDtoPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralTabListItemDtoPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    generalTabGET2(id: string): Observable<GeneralTabDto> {
        let url_ = this.baseUrl + "/api/GeneralTab/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeneralTabGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeneralTabGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralTabDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralTabDto>;
        }));
    }

    protected processGeneralTabGET2(response: HttpResponseBase): Observable<GeneralTabDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralTabDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    generalTabPUT(id: string, body: GeneralTabDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/GeneralTab/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeneralTabPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeneralTabPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGeneralTabPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    currentState(id: string): Observable<ApprovalState> {
        let url_ = this.baseUrl + "/api/GeneralTab/{id}/current-state";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCurrentState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCurrentState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApprovalState>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApprovalState>;
        }));
    }

    protected processCurrentState(response: HttpResponseBase): Observable<ApprovalState> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    clone(id: string): Observable<string> {
        let url_ = this.baseUrl + "/api/GeneralTab/{id}/clone";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processClone(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    reportType(id: string, body: ReportType | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/GeneralTab/{id}/report-type";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReportType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReportType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReportType(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param format (optional) 
     * @return OK
     */
    export(generalTabId: string, format: ExportFormat | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/GeneralTab/{generalTabId}/export?";
        if (generalTabId === undefined || generalTabId === null)
            throw new globalThis.Error("The parameter 'generalTabId' must be defined.");
        url_ = url_.replace("{generalTabId}", encodeURIComponent("" + generalTabId));
        if (format === null)
            throw new globalThis.Error("The parameter 'format' cannot be null.");
        else if (format !== undefined)
            url_ += "format=" + encodeURIComponent("" + format) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    health(): Observable<void> {
        let url_ = this.baseUrl + "/api/Health";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHealth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHealth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processHealth(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    timeline(generalTabId: string): Observable<TimelineItemDto[]> {
        let url_ = this.baseUrl + "/api/NotesAndAttachments/{generalTabId}/timeline";
        if (generalTabId === undefined || generalTabId === null)
            throw new globalThis.Error("The parameter 'generalTabId' must be defined.");
        url_ = url_.replace("{generalTabId}", encodeURIComponent("" + generalTabId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTimeline(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTimeline(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TimelineItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TimelineItemDto[]>;
        }));
    }

    protected processTimeline(response: HttpResponseBase): Observable<TimelineItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TimelineItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param title (optional) 
     * @param text (optional) 
     * @param files (optional) 
     * @return OK
     */
    notesPOST(generalTabId: string, title: string | undefined, text: string | undefined, files: FileParameter[] | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/NotesAndAttachments/{generalTabId}/notes";
        if (generalTabId === undefined || generalTabId === null)
            throw new globalThis.Error("The parameter 'generalTabId' must be defined.");
        url_ = url_.replace("{generalTabId}", encodeURIComponent("" + generalTabId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (title === null || title === undefined)
            throw new globalThis.Error("The parameter 'title' cannot be null.");
        else
            content_.append("title", title.toString());
        if (text === null || text === undefined)
            throw new globalThis.Error("The parameter 'text' cannot be null.");
        else
            content_.append("text", text.toString());
        if (files === null || files === undefined)
            throw new globalThis.Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotesPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotesPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processNotesPOST(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    notesDELETE(fileAttachedToNodeId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/NotesAndAttachments/notes/{fileAttachedToNodeId}";
        if (fileAttachedToNodeId === undefined || fileAttachedToNodeId === null)
            throw new globalThis.Error("The parameter 'fileAttachedToNodeId' must be defined.");
        url_ = url_.replace("{fileAttachedToNodeId}", encodeURIComponent("" + fileAttachedToNodeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotesDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotesDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processNotesDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param noteId (optional) 
     * @param filesAttachedNoteId (optional) 
     * @param title (optional) 
     * @param text (optional) 
     * @param addFiles (optional) 
     * @param deleteAttachmentIds (optional) 
     * @param deleteAttachmentId (optional) 
     * @return OK
     */
    notesPUT(generalTabId: string, noteId: number | undefined, filesAttachedNoteId: number | undefined, title: string | undefined, text: string | undefined, addFiles: FileParameter[] | undefined, deleteAttachmentIds: number[] | undefined, deleteAttachmentId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/NotesAndAttachments/notes/{generalTabId}";
        if (generalTabId === undefined || generalTabId === null)
            throw new globalThis.Error("The parameter 'generalTabId' must be defined.");
        url_ = url_.replace("{generalTabId}", encodeURIComponent("" + generalTabId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (noteId === null || noteId === undefined)
            throw new globalThis.Error("The parameter 'noteId' cannot be null.");
        else
            content_.append("NoteId", noteId.toString());
        if (filesAttachedNoteId === null || filesAttachedNoteId === undefined)
            throw new globalThis.Error("The parameter 'filesAttachedNoteId' cannot be null.");
        else
            content_.append("FilesAttachedNoteId", filesAttachedNoteId.toString());
        if (title === null || title === undefined)
            throw new globalThis.Error("The parameter 'title' cannot be null.");
        else
            content_.append("Title", title.toString());
        if (text === null || text === undefined)
            throw new globalThis.Error("The parameter 'text' cannot be null.");
        else
            content_.append("Text", text.toString());
        if (addFiles === null || addFiles === undefined)
            throw new globalThis.Error("The parameter 'addFiles' cannot be null.");
        else
            addFiles.forEach(item_ => content_.append("AddFiles", item_.data, item_.fileName ? item_.fileName : "AddFiles") );
        if (deleteAttachmentIds === null || deleteAttachmentIds === undefined)
            throw new globalThis.Error("The parameter 'deleteAttachmentIds' cannot be null.");
        else
            deleteAttachmentIds.forEach(item_ => content_.append("DeleteAttachmentIds", item_.toString()));
        if (deleteAttachmentId === null || deleteAttachmentId === undefined)
            throw new globalThis.Error("The parameter 'deleteAttachmentId' cannot be null.");
        else
            content_.append("DeleteAttachmentId", deleteAttachmentId.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotesPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotesPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processNotesPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param riskCommentId (optional) 
     * @return OK
     */
    attachments(generalTabId: string, riskCommentId: number | undefined): Observable<AttachmentDto[]> {
        let url_ = this.baseUrl + "/api/NotesAndAttachments/{generalTabId}/attachments?";
        if (generalTabId === undefined || generalTabId === null)
            throw new globalThis.Error("The parameter 'generalTabId' must be defined.");
        url_ = url_.replace("{generalTabId}", encodeURIComponent("" + generalTabId));
        if (riskCommentId === null)
            throw new globalThis.Error("The parameter 'riskCommentId' cannot be null.");
        else if (riskCommentId !== undefined)
            url_ += "riskCommentId=" + encodeURIComponent("" + riskCommentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAttachments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAttachments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttachmentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttachmentDto[]>;
        }));
    }

    protected processAttachments(response: HttpResponseBase): Observable<AttachmentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttachmentDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    download(blobName: string): Observable<void> {
        let url_ = this.baseUrl + "/api/NotesAndAttachments/attachments/{blobName}/download";
        if (blobName === undefined || blobName === null)
            throw new globalThis.Error("The parameter 'blobName' must be defined.");
        url_ = url_.replace("{blobName}", encodeURIComponent("" + blobName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDownload(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    download2(blobName: string): Observable<void> {
        let url_ = this.baseUrl + "/api/NotesAndAttachments/riskevaluation/{blobName}/download";
        if (blobName === undefined || blobName === null)
            throw new globalThis.Error("The parameter 'blobName' must be defined.");
        url_ = url_.replace("{blobName}", encodeURIComponent("" + blobName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownload2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownload2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDownload2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    preview(blobName: string): Observable<void> {
        let url_ = this.baseUrl + "/api/NotesAndAttachments/attachments/{blobName}/preview";
        if (blobName === undefined || blobName === null)
            throw new globalThis.Error("The parameter 'blobName' must be defined.");
        url_ = url_.replace("{blobName}", encodeURIComponent("" + blobName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPreview(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    preview2(blobName: string): Observable<void> {
        let url_ = this.baseUrl + "/api/NotesAndAttachments/riskevaluation/{blobName}/preview";
        if (blobName === undefined || blobName === null)
            throw new globalThis.Error("The parameter 'blobName' must be defined.");
        url_ = url_.replace("{blobName}", encodeURIComponent("" + blobName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPreview2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPreview2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPreview2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    emails(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/PeopleData/emails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processEmails(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    sharedEmail(sharedEmail: string): Observable<string[]> {
        let url_ = this.baseUrl + "/api/PeopleData/shared-email/{sharedEmail}";
        if (sharedEmail === undefined || sharedEmail === null)
            throw new globalThis.Error("The parameter 'sharedEmail' must be defined.");
        url_ = url_.replace("{sharedEmail}", encodeURIComponent("" + sharedEmail));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSharedEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSharedEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processSharedEmail(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    email(email: string): Observable<GetPeopleDataByEmailResponseDto[]> {
        let url_ = this.baseUrl + "/api/PeopleData/email/{email}";
        if (email === undefined || email === null)
            throw new globalThis.Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPeopleDataByEmailResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPeopleDataByEmailResponseDto[]>;
        }));
    }

    protected processEmail(response: HttpResponseBase): Observable<GetPeopleDataByEmailResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetPeopleDataByEmailResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    peopleBriefData(email: string): Observable<PeopleBriefDataByEmailDto> {
        let url_ = this.baseUrl + "/api/PeopleData/people-brief-data/{email}";
        if (email === undefined || email === null)
            throw new globalThis.Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPeopleBriefData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPeopleBriefData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PeopleBriefDataByEmailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PeopleBriefDataByEmailDto>;
        }));
    }

    protected processPeopleBriefData(response: HttpResponseBase): Observable<PeopleBriefDataByEmailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PeopleBriefDataByEmailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    azureObjectId(azureObjectId: string): Observable<PeopleBriefDataDto> {
        let url_ = this.baseUrl + "/api/PeopleData/azure-object-id/{azureObjectId}";
        if (azureObjectId === undefined || azureObjectId === null)
            throw new globalThis.Error("The parameter 'azureObjectId' must be defined.");
        url_ = url_.replace("{azureObjectId}", encodeURIComponent("" + azureObjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAzureObjectId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAzureObjectId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PeopleBriefDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PeopleBriefDataDto>;
        }));
    }

    protected processAzureObjectId(response: HttpResponseBase): Observable<PeopleBriefDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PeopleBriefDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    referencesGET(generalTabId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Reference/tabs/{generalTabId}/references";
        if (generalTabId === undefined || generalTabId === null)
            throw new globalThis.Error("The parameter 'generalTabId' must be defined.");
        url_ = url_.replace("{generalTabId}", encodeURIComponent("" + generalTabId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReferencesGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReferencesGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReferencesGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    referencesPOST(generalTabId: string, body: CreateRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Reference/tabs/{generalTabId}/references";
        if (generalTabId === undefined || generalTabId === null)
            throw new globalThis.Error("The parameter 'generalTabId' must be defined.");
        url_ = url_.replace("{generalTabId}", encodeURIComponent("" + generalTabId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReferencesPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReferencesPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReferencesPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    referencesPUT(generalTabId: string, id: number, body: UpdateRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Reference/tabs/{generalTabId}/references/{id}";
        if (generalTabId === undefined || generalTabId === null)
            throw new globalThis.Error("The parameter 'generalTabId' must be defined.");
        url_ = url_.replace("{generalTabId}", encodeURIComponent("" + generalTabId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReferencesPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReferencesPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReferencesPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    referencesDELETE(generalTabId: string, id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Reference/tabs/{generalTabId}/references/{id}";
        if (generalTabId === undefined || generalTabId === null)
            throw new globalThis.Error("The parameter 'generalTabId' must be defined.");
        url_ = url_.replace("{generalTabId}", encodeURIComponent("" + generalTabId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReferencesDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReferencesDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReferencesDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    tlrEntriesGET(generalTabId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Reference/tabs/{generalTabId}/tlr-entries";
        if (generalTabId === undefined || generalTabId === null)
            throw new globalThis.Error("The parameter 'generalTabId' must be defined.");
        url_ = url_.replace("{generalTabId}", encodeURIComponent("" + generalTabId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTlrEntriesGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTlrEntriesGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTlrEntriesGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    tlrEntriesPOST(generalTabId: string, body: TlrEntryDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Reference/tabs/{generalTabId}/tlr-entries";
        if (generalTabId === undefined || generalTabId === null)
            throw new globalThis.Error("The parameter 'generalTabId' must be defined.");
        url_ = url_.replace("{generalTabId}", encodeURIComponent("" + generalTabId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTlrEntriesPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTlrEntriesPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTlrEntriesPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    tlrEntriesPUT(generalTabId: string, id: string, body: TlrEntryDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Reference/tabs/{generalTabId}/tlr-entries/{id}";
        if (generalTabId === undefined || generalTabId === null)
            throw new globalThis.Error("The parameter 'generalTabId' must be defined.");
        url_ = url_.replace("{generalTabId}", encodeURIComponent("" + generalTabId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTlrEntriesPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTlrEntriesPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTlrEntriesPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    tlrEntriesDELETE(generalTabId: string, id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Reference/tabs/{generalTabId}/tlr-entries/{id}";
        if (generalTabId === undefined || generalTabId === null)
            throw new globalThis.Error("The parameter 'generalTabId' must be defined.");
        url_ = url_.replace("{generalTabId}", encodeURIComponent("" + generalTabId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTlrEntriesDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTlrEntriesDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTlrEntriesDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    resolutionAndMitigationPlanPOST(body: ResolutionAndMitigationPlanDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/ResolutionAndMitigationPlan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResolutionAndMitigationPlanPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResolutionAndMitigationPlanPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processResolutionAndMitigationPlanPOST(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : null as any;
    
            return _observableOf(result201);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    resolutionAndMitigationPlanPUT(body: ResolutionAndMitigationPlanDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ResolutionAndMitigationPlan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResolutionAndMitigationPlanPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResolutionAndMitigationPlanPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResolutionAndMitigationPlanPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    byGeneralTab4(generalTabId: string): Observable<ResolutionAndMitigationPlanDto> {
        let url_ = this.baseUrl + "/api/ResolutionAndMitigationPlan/by-general-tab/{generalTabId}";
        if (generalTabId === undefined || generalTabId === null)
            throw new globalThis.Error("The parameter 'generalTabId' must be defined.");
        url_ = url_.replace("{generalTabId}", encodeURIComponent("" + generalTabId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processByGeneralTab4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processByGeneralTab4(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResolutionAndMitigationPlanDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResolutionAndMitigationPlanDto>;
        }));
    }

    protected processByGeneralTab4(response: HttpResponseBase): Observable<ResolutionAndMitigationPlanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResolutionAndMitigationPlanDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    riptTabPOST(body: RiptTabDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/RiptTab";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRiptTabPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRiptTabPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processRiptTabPOST(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : null as any;
    
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    byGeneralTab5(generalTabId: string): Observable<RiptTabDto> {
        let url_ = this.baseUrl + "/api/RiptTab/by-general-tab/{generalTabId}";
        if (generalTabId === undefined || generalTabId === null)
            throw new globalThis.Error("The parameter 'generalTabId' must be defined.");
        url_ = url_.replace("{generalTabId}", encodeURIComponent("" + generalTabId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processByGeneralTab5(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processByGeneralTab5(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RiptTabDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RiptTabDto>;
        }));
    }

    protected processByGeneralTab5(response: HttpResponseBase): Observable<RiptTabDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RiptTabDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param url (optional) 
     * @return OK
     */
    riptData(url: string | undefined): Observable<{ [key: string]: any; }[]> {
        let url_ = this.baseUrl + "/api/RiptTab/ript-data?";
        if (url === null)
            throw new globalThis.Error("The parameter 'url' cannot be null.");
        else if (url !== undefined)
            url_ += "url=" + encodeURIComponent("" + url) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRiptData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRiptData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: any; }[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: any; }[]>;
        }));
    }

    protected processRiptData(response: HttpResponseBase): Observable<{ [key: string]: any; }[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    riptTabPUT(id: number, body: RiptTabDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/RiptTab/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRiptTabPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRiptTabPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRiptTabPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    requestRipt(generalTabId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/RiptTab/request-ript/{generalTabId}";
        if (generalTabId === undefined || generalTabId === null)
            throw new globalThis.Error("The parameter 'generalTabId' must be defined.");
        url_ = url_.replace("{generalTabId}", encodeURIComponent("" + generalTabId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestRipt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestRipt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRequestRipt(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null as any;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param riskCommentDto_Id (optional) 
     * @param riskCommentDto_HealthAndSafetyComment (optional) 
     * @param riskCommentDto_EnvironmentalComment (optional) 
     * @param riskCommentDto_ReputationComment (optional) 
     * @param riskCommentDto_AssetComment (optional) 
     * @param riskCommentDto_RiskAssessmentComments (optional) 
     * @param riskCommentDto_AttachRiskEvaluationFormPath (optional) 
     * @param riskCommentDto_AttachRiskEvaluationForm (optional) 
     * @param riskEvaluationDtos (optional) 
     * @return Created
     */
    riskEvaluationPOST(riskCommentDto_Id: number | undefined, riskCommentDto_HealthAndSafetyComment: string | undefined, riskCommentDto_EnvironmentalComment: string | undefined, riskCommentDto_ReputationComment: string | undefined, riskCommentDto_AssetComment: string | undefined, riskCommentDto_RiskAssessmentComments: string | undefined, riskCommentDto_AttachRiskEvaluationFormPath: string | undefined, riskCommentDto_AttachRiskEvaluationForm: FileParameter | undefined, riskEvaluationDtos: RiskEvaluationDto[] | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/RiskEvaluation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (riskCommentDto_Id === null || riskCommentDto_Id === undefined)
            throw new globalThis.Error("The parameter 'riskCommentDto_Id' cannot be null.");
        else
            content_.append("RiskCommentDto.Id", riskCommentDto_Id.toString());
        if (riskCommentDto_HealthAndSafetyComment === null || riskCommentDto_HealthAndSafetyComment === undefined)
            throw new globalThis.Error("The parameter 'riskCommentDto_HealthAndSafetyComment' cannot be null.");
        else
            content_.append("RiskCommentDto.HealthAndSafetyComment", riskCommentDto_HealthAndSafetyComment.toString());
        if (riskCommentDto_EnvironmentalComment === null || riskCommentDto_EnvironmentalComment === undefined)
            throw new globalThis.Error("The parameter 'riskCommentDto_EnvironmentalComment' cannot be null.");
        else
            content_.append("RiskCommentDto.EnvironmentalComment", riskCommentDto_EnvironmentalComment.toString());
        if (riskCommentDto_ReputationComment === null || riskCommentDto_ReputationComment === undefined)
            throw new globalThis.Error("The parameter 'riskCommentDto_ReputationComment' cannot be null.");
        else
            content_.append("RiskCommentDto.ReputationComment", riskCommentDto_ReputationComment.toString());
        if (riskCommentDto_AssetComment === null || riskCommentDto_AssetComment === undefined)
            throw new globalThis.Error("The parameter 'riskCommentDto_AssetComment' cannot be null.");
        else
            content_.append("RiskCommentDto.AssetComment", riskCommentDto_AssetComment.toString());
        if (riskCommentDto_RiskAssessmentComments === null || riskCommentDto_RiskAssessmentComments === undefined)
            throw new globalThis.Error("The parameter 'riskCommentDto_RiskAssessmentComments' cannot be null.");
        else
            content_.append("RiskCommentDto.RiskAssessmentComments", riskCommentDto_RiskAssessmentComments.toString());
        if (riskCommentDto_AttachRiskEvaluationFormPath === null || riskCommentDto_AttachRiskEvaluationFormPath === undefined)
            throw new globalThis.Error("The parameter 'riskCommentDto_AttachRiskEvaluationFormPath' cannot be null.");
        else
            content_.append("RiskCommentDto.AttachRiskEvaluationFormPath", riskCommentDto_AttachRiskEvaluationFormPath.toString());
        if (riskCommentDto_AttachRiskEvaluationForm === null || riskCommentDto_AttachRiskEvaluationForm === undefined)
            throw new globalThis.Error("The parameter 'riskCommentDto_AttachRiskEvaluationForm' cannot be null.");
        else
            content_.append("RiskCommentDto.AttachRiskEvaluationForm", riskCommentDto_AttachRiskEvaluationForm.data, riskCommentDto_AttachRiskEvaluationForm.fileName ? riskCommentDto_AttachRiskEvaluationForm.fileName : "RiskCommentDto.AttachRiskEvaluationForm");
        if (riskEvaluationDtos === null || riskEvaluationDtos === undefined)
            throw new globalThis.Error("The parameter 'riskEvaluationDtos' cannot be null.");
        else
            riskEvaluationDtos.forEach(item_ => content_.append("RiskEvaluationDtos", item_.toString()));

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRiskEvaluationPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRiskEvaluationPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processRiskEvaluationPOST(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : null as any;
    
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param riskCommentDto_Id (optional) 
     * @param riskCommentDto_HealthAndSafetyComment (optional) 
     * @param riskCommentDto_EnvironmentalComment (optional) 
     * @param riskCommentDto_ReputationComment (optional) 
     * @param riskCommentDto_AssetComment (optional) 
     * @param riskCommentDto_RiskAssessmentComments (optional) 
     * @param riskCommentDto_AttachRiskEvaluationFormPath (optional) 
     * @param riskCommentDto_AttachRiskEvaluationForm (optional) 
     * @param riskEvaluationDtos (optional) 
     * @return No Content
     */
    riskEvaluationPUT(riskCommentDto_Id: number | undefined, riskCommentDto_HealthAndSafetyComment: string | undefined, riskCommentDto_EnvironmentalComment: string | undefined, riskCommentDto_ReputationComment: string | undefined, riskCommentDto_AssetComment: string | undefined, riskCommentDto_RiskAssessmentComments: string | undefined, riskCommentDto_AttachRiskEvaluationFormPath: string | undefined, riskCommentDto_AttachRiskEvaluationForm: FileParameter | undefined, riskEvaluationDtos: RiskEvaluationDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/RiskEvaluation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (riskCommentDto_Id === null || riskCommentDto_Id === undefined)
            throw new globalThis.Error("The parameter 'riskCommentDto_Id' cannot be null.");
        else
            content_.append("RiskCommentDto.Id", riskCommentDto_Id.toString());
        if (riskCommentDto_HealthAndSafetyComment === null || riskCommentDto_HealthAndSafetyComment === undefined)
            throw new globalThis.Error("The parameter 'riskCommentDto_HealthAndSafetyComment' cannot be null.");
        else
            content_.append("RiskCommentDto.HealthAndSafetyComment", riskCommentDto_HealthAndSafetyComment.toString());
        if (riskCommentDto_EnvironmentalComment === null || riskCommentDto_EnvironmentalComment === undefined)
            throw new globalThis.Error("The parameter 'riskCommentDto_EnvironmentalComment' cannot be null.");
        else
            content_.append("RiskCommentDto.EnvironmentalComment", riskCommentDto_EnvironmentalComment.toString());
        if (riskCommentDto_ReputationComment === null || riskCommentDto_ReputationComment === undefined)
            throw new globalThis.Error("The parameter 'riskCommentDto_ReputationComment' cannot be null.");
        else
            content_.append("RiskCommentDto.ReputationComment", riskCommentDto_ReputationComment.toString());
        if (riskCommentDto_AssetComment === null || riskCommentDto_AssetComment === undefined)
            throw new globalThis.Error("The parameter 'riskCommentDto_AssetComment' cannot be null.");
        else
            content_.append("RiskCommentDto.AssetComment", riskCommentDto_AssetComment.toString());
        if (riskCommentDto_RiskAssessmentComments === null || riskCommentDto_RiskAssessmentComments === undefined)
            throw new globalThis.Error("The parameter 'riskCommentDto_RiskAssessmentComments' cannot be null.");
        else
            content_.append("RiskCommentDto.RiskAssessmentComments", riskCommentDto_RiskAssessmentComments.toString());
        if (riskCommentDto_AttachRiskEvaluationFormPath === null || riskCommentDto_AttachRiskEvaluationFormPath === undefined)
            throw new globalThis.Error("The parameter 'riskCommentDto_AttachRiskEvaluationFormPath' cannot be null.");
        else
            content_.append("RiskCommentDto.AttachRiskEvaluationFormPath", riskCommentDto_AttachRiskEvaluationFormPath.toString());
        if (riskCommentDto_AttachRiskEvaluationForm === null || riskCommentDto_AttachRiskEvaluationForm === undefined)
            throw new globalThis.Error("The parameter 'riskCommentDto_AttachRiskEvaluationForm' cannot be null.");
        else
            content_.append("RiskCommentDto.AttachRiskEvaluationForm", riskCommentDto_AttachRiskEvaluationForm.data, riskCommentDto_AttachRiskEvaluationForm.fileName ? riskCommentDto_AttachRiskEvaluationForm.fileName : "RiskCommentDto.AttachRiskEvaluationForm");
        if (riskEvaluationDtos === null || riskEvaluationDtos === undefined)
            throw new globalThis.Error("The parameter 'riskEvaluationDtos' cannot be null.");
        else
            riskEvaluationDtos.forEach(item_ => content_.append("RiskEvaluationDtos", item_.toString()));

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRiskEvaluationPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRiskEvaluationPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRiskEvaluationPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    byGeneralTabAll2(generalTabId: string): Observable<RiskEvaluationDto[]> {
        let url_ = this.baseUrl + "/api/RiskEvaluation/by-general-tab/{generalTabId}";
        if (generalTabId === undefined || generalTabId === null)
            throw new globalThis.Error("The parameter 'generalTabId' must be defined.");
        url_ = url_.replace("{generalTabId}", encodeURIComponent("" + generalTabId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processByGeneralTabAll2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processByGeneralTabAll2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RiskEvaluationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RiskEvaluationDto[]>;
        }));
    }

    protected processByGeneralTabAll2(response: HttpResponseBase): Observable<RiskEvaluationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RiskEvaluationDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    download3(blobName: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/RiskEvaluation/download/{blobName}";
        if (blobName === undefined || blobName === null)
            throw new globalThis.Error("The parameter 'blobName' must be defined.");
        url_ = url_.replace("{blobName}", encodeURIComponent("" + blobName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownload3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownload3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownload3(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    file(riskCommentId: number, blobName: string): Observable<void> {
        let url_ = this.baseUrl + "/api/RiskEvaluation/file/{riskCommentId}/{blobName}";
        if (riskCommentId === undefined || riskCommentId === null)
            throw new globalThis.Error("The parameter 'riskCommentId' must be defined.");
        url_ = url_.replace("{riskCommentId}", encodeURIComponent("" + riskCommentId));
        if (blobName === undefined || blobName === null)
            throw new globalThis.Error("The parameter 'blobName' must be defined.");
        url_ = url_.replace("{blobName}", encodeURIComponent("" + blobName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export enum AMALType {
    A = "A",
    B = "B",
    C = "C",
    D = "D",
}

export class ActionItemDto implements IActionItemDto {
    id?: number;
    deviationReportID?: string | undefined;
    generalTabId?: string | undefined;
    actionItemId?: string | undefined;
    status?: ActionItemStatus;
    workScope!: ActionItemWorkScope;
    actionType!: ActionItemType;
    actionItemOwner!: string;
    actionItemDescriptionEn!: string;
    actionItemDescriptionRu?: string | undefined;
    actionItemDescriptionKz?: string | undefined;
    progress?: number | undefined;
    dueDate!: Date;
    createdOn?: Date | undefined;
    completedOn?: Date | undefined;
    resolutionAndMitigationPlanId?: number | undefined;

    constructor(data?: IActionItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.deviationReportID = _data["deviationReportID"];
            this.generalTabId = _data["generalTabId"];
            this.actionItemId = _data["actionItemId"];
            this.status = _data["status"];
            this.workScope = _data["workScope"];
            this.actionType = _data["actionType"];
            this.actionItemOwner = _data["actionItemOwner"];
            this.actionItemDescriptionEn = _data["actionItemDescriptionEn"];
            this.actionItemDescriptionRu = _data["actionItemDescriptionRu"];
            this.actionItemDescriptionKz = _data["actionItemDescriptionKz"];
            this.progress = _data["progress"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : undefined as any;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.completedOn = _data["completedOn"] ? new Date(_data["completedOn"].toString()) : undefined as any;
            this.resolutionAndMitigationPlanId = _data["resolutionAndMitigationPlanId"];
        }
    }

    static fromJS(data: any): ActionItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deviationReportID"] = this.deviationReportID;
        data["generalTabId"] = this.generalTabId;
        data["actionItemId"] = this.actionItemId;
        data["status"] = this.status;
        data["workScope"] = this.workScope;
        data["actionType"] = this.actionType;
        data["actionItemOwner"] = this.actionItemOwner;
        data["actionItemDescriptionEn"] = this.actionItemDescriptionEn;
        data["actionItemDescriptionRu"] = this.actionItemDescriptionRu;
        data["actionItemDescriptionKz"] = this.actionItemDescriptionKz;
        data["progress"] = this.progress;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : undefined as any;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["completedOn"] = this.completedOn ? this.completedOn.toISOString() : undefined as any;
        data["resolutionAndMitigationPlanId"] = this.resolutionAndMitigationPlanId;
        return data;
    }
}

export interface IActionItemDto {
    id?: number;
    deviationReportID?: string | undefined;
    generalTabId?: string | undefined;
    actionItemId?: string | undefined;
    status?: ActionItemStatus;
    workScope: ActionItemWorkScope;
    actionType: ActionItemType;
    actionItemOwner: string;
    actionItemDescriptionEn: string;
    actionItemDescriptionRu?: string | undefined;
    actionItemDescriptionKz?: string | undefined;
    progress?: number | undefined;
    dueDate: Date;
    createdOn?: Date | undefined;
    completedOn?: Date | undefined;
    resolutionAndMitigationPlanId?: number | undefined;
}

export class ActionItemDtoPagedResult implements IActionItemDtoPagedResult {
    items?: ActionItemDto[] | undefined;
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    readonly totalPages?: number;
    readonly hasNextPage?: boolean;
    readonly hasPreviousPage?: boolean;

    constructor(data?: IActionItemDtoPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ActionItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            (this as any).totalPages = _data["totalPages"];
            (this as any).hasNextPage = _data["hasNextPage"];
            (this as any).hasPreviousPage = _data["hasPreviousPage"];
        }
    }

    static fromJS(data: any): ActionItemDtoPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new ActionItemDtoPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasNextPage"] = this.hasNextPage;
        data["hasPreviousPage"] = this.hasPreviousPage;
        return data;
    }
}

export interface IActionItemDtoPagedResult {
    items?: ActionItemDto[] | undefined;
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
}

export enum ActionItemStatus {
    Draft = "Draft",
    Approved = "Approved",
    Completed = "Completed",
}

export enum ActionItemType {
    AdministrativeTask = "AdministrativeTask",
    MitigationTaskShortTerm = "MitigationTaskShortTerm",
    ResolutionTaskLongTerm = "ResolutionTaskLongTerm",
}

export enum ActionItemWorkScope {
    TA = "TA",
    NonTA = "NonTA",
    NotAssigned = "NotAssigned",
}

export class ApprovalFlowDto implements IApprovalFlowDto {
    id?: number;
    isRiptRequested?: boolean;
    areaLeadInspEng?: string | undefined;
    areaLeadInspEngDescription?: string | undefined;
    inspEngSupervisor?: string | undefined;
    inspEngSupervisorDescription?: string | undefined;
    srOpsConsultant?: string | undefined;
    srOpsConsultantDescription?: string | undefined;
    localTechnicalAuthority?: string | undefined;
    localTechnicalAuthorityDescription?: string | undefined;
    assetTypeHCEPO?: string | undefined;
    assetTypeHCEPODescription?: string | undefined;
    areaOpsSuperintendent?: string | undefined;
    areaOpsSuperintendentDescription?: string | undefined;
    productionOperationManager?: string | undefined;
    productionOperationManagerDescription?: string | undefined;
    generalManagerOperation?: string | undefined;
    generalManagerOperationDescription?: string | undefined;
    generalDirectorOperation?: string | undefined;
    generalDirectorOperationDescription?: string | undefined;
    informedEmailsTo?: string | undefined;
    informedEmailsCc?: string | undefined;
    additionalEndorser1?: string | undefined;
    additionalEndorser2?: string | undefined;
    additionalEndorser3?: string | undefined;
    hasAreaLeadApproved?: boolean | undefined;
    hasLTAApproved?: boolean | undefined;
    hasHCEPOApproved?: boolean | undefined;
    hasAreaOpsApproved?: boolean | undefined;
    hasProdOpManagerApproved?: boolean | undefined;
    hasGenManagerOperatorApproved?: boolean | undefined;
    hasDirectorApproved?: boolean | undefined;
    additionalEndorser1Endorsed?: boolean | undefined;
    additionalEndorser2Endorsed?: boolean | undefined;
    additionalEndorser3Endorsed?: boolean | undefined;
    generalTabId!: string;
    history?: ApprovalFlowHistoryDto[] | undefined;

    constructor(data?: IApprovalFlowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isRiptRequested = _data["isRiptRequested"];
            this.areaLeadInspEng = _data["areaLeadInspEng"];
            this.areaLeadInspEngDescription = _data["areaLeadInspEngDescription"];
            this.inspEngSupervisor = _data["inspEngSupervisor"];
            this.inspEngSupervisorDescription = _data["inspEngSupervisorDescription"];
            this.srOpsConsultant = _data["srOpsConsultant"];
            this.srOpsConsultantDescription = _data["srOpsConsultantDescription"];
            this.localTechnicalAuthority = _data["localTechnicalAuthority"];
            this.localTechnicalAuthorityDescription = _data["localTechnicalAuthorityDescription"];
            this.assetTypeHCEPO = _data["assetTypeHCEPO"];
            this.assetTypeHCEPODescription = _data["assetTypeHCEPODescription"];
            this.areaOpsSuperintendent = _data["areaOpsSuperintendent"];
            this.areaOpsSuperintendentDescription = _data["areaOpsSuperintendentDescription"];
            this.productionOperationManager = _data["productionOperationManager"];
            this.productionOperationManagerDescription = _data["productionOperationManagerDescription"];
            this.generalManagerOperation = _data["generalManagerOperation"];
            this.generalManagerOperationDescription = _data["generalManagerOperationDescription"];
            this.generalDirectorOperation = _data["generalDirectorOperation"];
            this.generalDirectorOperationDescription = _data["generalDirectorOperationDescription"];
            this.informedEmailsTo = _data["informedEmailsTo"];
            this.informedEmailsCc = _data["informedEmailsCc"];
            this.additionalEndorser1 = _data["additionalEndorser1"];
            this.additionalEndorser2 = _data["additionalEndorser2"];
            this.additionalEndorser3 = _data["additionalEndorser3"];
            this.hasAreaLeadApproved = _data["hasAreaLeadApproved"];
            this.hasLTAApproved = _data["hasLTAApproved"];
            this.hasHCEPOApproved = _data["hasHCEPOApproved"];
            this.hasAreaOpsApproved = _data["hasAreaOpsApproved"];
            this.hasProdOpManagerApproved = _data["hasProdOpManagerApproved"];
            this.hasGenManagerOperatorApproved = _data["hasGenManagerOperatorApproved"];
            this.hasDirectorApproved = _data["hasDirectorApproved"];
            this.additionalEndorser1Endorsed = _data["additionalEndorser1Endorsed"];
            this.additionalEndorser2Endorsed = _data["additionalEndorser2Endorsed"];
            this.additionalEndorser3Endorsed = _data["additionalEndorser3Endorsed"];
            this.generalTabId = _data["generalTabId"];
            if (Array.isArray(_data["history"])) {
                this.history = [] as any;
                for (let item of _data["history"])
                    this.history!.push(ApprovalFlowHistoryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ApprovalFlowDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApprovalFlowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isRiptRequested"] = this.isRiptRequested;
        data["areaLeadInspEng"] = this.areaLeadInspEng;
        data["areaLeadInspEngDescription"] = this.areaLeadInspEngDescription;
        data["inspEngSupervisor"] = this.inspEngSupervisor;
        data["inspEngSupervisorDescription"] = this.inspEngSupervisorDescription;
        data["srOpsConsultant"] = this.srOpsConsultant;
        data["srOpsConsultantDescription"] = this.srOpsConsultantDescription;
        data["localTechnicalAuthority"] = this.localTechnicalAuthority;
        data["localTechnicalAuthorityDescription"] = this.localTechnicalAuthorityDescription;
        data["assetTypeHCEPO"] = this.assetTypeHCEPO;
        data["assetTypeHCEPODescription"] = this.assetTypeHCEPODescription;
        data["areaOpsSuperintendent"] = this.areaOpsSuperintendent;
        data["areaOpsSuperintendentDescription"] = this.areaOpsSuperintendentDescription;
        data["productionOperationManager"] = this.productionOperationManager;
        data["productionOperationManagerDescription"] = this.productionOperationManagerDescription;
        data["generalManagerOperation"] = this.generalManagerOperation;
        data["generalManagerOperationDescription"] = this.generalManagerOperationDescription;
        data["generalDirectorOperation"] = this.generalDirectorOperation;
        data["generalDirectorOperationDescription"] = this.generalDirectorOperationDescription;
        data["informedEmailsTo"] = this.informedEmailsTo;
        data["informedEmailsCc"] = this.informedEmailsCc;
        data["additionalEndorser1"] = this.additionalEndorser1;
        data["additionalEndorser2"] = this.additionalEndorser2;
        data["additionalEndorser3"] = this.additionalEndorser3;
        data["hasAreaLeadApproved"] = this.hasAreaLeadApproved;
        data["hasLTAApproved"] = this.hasLTAApproved;
        data["hasHCEPOApproved"] = this.hasHCEPOApproved;
        data["hasAreaOpsApproved"] = this.hasAreaOpsApproved;
        data["hasProdOpManagerApproved"] = this.hasProdOpManagerApproved;
        data["hasGenManagerOperatorApproved"] = this.hasGenManagerOperatorApproved;
        data["hasDirectorApproved"] = this.hasDirectorApproved;
        data["additionalEndorser1Endorsed"] = this.additionalEndorser1Endorsed;
        data["additionalEndorser2Endorsed"] = this.additionalEndorser2Endorsed;
        data["additionalEndorser3Endorsed"] = this.additionalEndorser3Endorsed;
        data["generalTabId"] = this.generalTabId;
        if (Array.isArray(this.history)) {
            data["history"] = [];
            for (let item of this.history)
                data["history"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IApprovalFlowDto {
    id?: number;
    isRiptRequested?: boolean;
    areaLeadInspEng?: string | undefined;
    areaLeadInspEngDescription?: string | undefined;
    inspEngSupervisor?: string | undefined;
    inspEngSupervisorDescription?: string | undefined;
    srOpsConsultant?: string | undefined;
    srOpsConsultantDescription?: string | undefined;
    localTechnicalAuthority?: string | undefined;
    localTechnicalAuthorityDescription?: string | undefined;
    assetTypeHCEPO?: string | undefined;
    assetTypeHCEPODescription?: string | undefined;
    areaOpsSuperintendent?: string | undefined;
    areaOpsSuperintendentDescription?: string | undefined;
    productionOperationManager?: string | undefined;
    productionOperationManagerDescription?: string | undefined;
    generalManagerOperation?: string | undefined;
    generalManagerOperationDescription?: string | undefined;
    generalDirectorOperation?: string | undefined;
    generalDirectorOperationDescription?: string | undefined;
    informedEmailsTo?: string | undefined;
    informedEmailsCc?: string | undefined;
    additionalEndorser1?: string | undefined;
    additionalEndorser2?: string | undefined;
    additionalEndorser3?: string | undefined;
    hasAreaLeadApproved?: boolean | undefined;
    hasLTAApproved?: boolean | undefined;
    hasHCEPOApproved?: boolean | undefined;
    hasAreaOpsApproved?: boolean | undefined;
    hasProdOpManagerApproved?: boolean | undefined;
    hasGenManagerOperatorApproved?: boolean | undefined;
    hasDirectorApproved?: boolean | undefined;
    additionalEndorser1Endorsed?: boolean | undefined;
    additionalEndorser2Endorsed?: boolean | undefined;
    additionalEndorser3Endorsed?: boolean | undefined;
    generalTabId: string;
    history?: ApprovalFlowHistoryDto[] | undefined;
}

export class ApprovalFlowHistoryDto implements IApprovalFlowHistoryDto {
    currentState?: ApprovalState;
    actionItemStatus?: ActionItemStatus;
    created?: Date;
    createdBy?: string | undefined;
    comment?: string | undefined;
    type?: string | undefined;

    constructor(data?: IApprovalFlowHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentState = _data["currentState"];
            this.actionItemStatus = _data["actionItemStatus"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.comment = _data["comment"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): ApprovalFlowHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApprovalFlowHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentState"] = this.currentState;
        data["actionItemStatus"] = this.actionItemStatus;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["comment"] = this.comment;
        data["type"] = this.type;
        return data;
    }
}

export interface IApprovalFlowHistoryDto {
    currentState?: ApprovalState;
    actionItemStatus?: ActionItemStatus;
    created?: Date;
    createdBy?: string | undefined;
    comment?: string | undefined;
    type?: string | undefined;
}

export class ApprovalFlowStepDto implements IApprovalFlowStepDto {
    state?: ApprovalState;
    email?: string | undefined;

    constructor(data?: IApprovalFlowStepDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ApprovalFlowStepDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApprovalFlowStepDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["email"] = this.email;
        return data;
    }
}

export interface IApprovalFlowStepDto {
    state?: ApprovalState;
    email?: string | undefined;
}

export enum ApprovalState {
    Draft = "Draft",
    DraftedForReview = "DraftedForReview",
    SubmittedToOpsAdvisor = "SubmittedToOpsAdvisor",
    PlanConfirmed = "PlanConfirmed",
    RIPTScored = "RIPTScored",
    RiskEvaluationScored = "RiskEvaluationScored",
    PlanEndorsed = "PlanEndorsed",
    PlanApproved = "PlanApproved",
    ResolutionPlanCompleted = "ResolutionPlanCompleted",
    ValidationAndVerificationCompleted = "ValidationAndVerificationCompleted",
    Closed = "Closed",
    Cancelled = "Cancelled",
    OutOfService = "OutOfService",
    Recycle = "Recycle",
}

export enum ApprovalUserRole {
    GeneralDirector = "GeneralDirector",
    AreaLeadInspEng = "AreaLeadInspEng",
    InspEngSupervisor = "InspEngSupervisor",
    OpsAdvisor = "OpsAdvisor",
    FastRepi = "FastRepi",
    ActionItemOwner = "ActionItemOwner",
    Owner = "Owner",
    LocalTechnicalAuthority = "LocalTechnicalAuthority",
    AssetTypeHCEPO = "AssetTypeHCEPO",
    AreaOpsSuperintendent = "AreaOpsSuperintendent",
    ProductionOperationManager = "ProductionOperationManager",
    GeneralManagerOperation = "GeneralManagerOperation",
    Initiator = "Initiator",
    AdditionalEndorser1 = "AdditionalEndorser1",
    AdditionalEndorser2 = "AdditionalEndorser2",
    AdditionalEndorser3 = "AdditionalEndorser3",
}

export class AttachmentDto implements IAttachmentDto {
    id?: number;
    description?: string | undefined;
    fileName?: string | undefined;
    blobName?: string | undefined;

    constructor(data?: IAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.fileName = _data["fileName"];
            this.blobName = _data["blobName"];
        }
    }

    static fromJS(data: any): AttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["fileName"] = this.fileName;
        data["blobName"] = this.blobName;
        return data;
    }
}

export interface IAttachmentDto {
    id?: number;
    description?: string | undefined;
    fileName?: string | undefined;
    blobName?: string | undefined;
}

export enum AuditEvent {
    Created = "Created",
    Updated = "Updated",
    Deleted = "Deleted",
    Assigned = "Assigned",
}

export class AuditLogEntryDto implements IAuditLogEntryDto {
    entityName?: string | undefined;
    generalTabId?: string;
    changedDate?: Date;
    changedBy?: string | undefined;
    event?: AuditEvent;
    changedField?: string | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;

    constructor(data?: IAuditLogEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityName = _data["entityName"];
            this.generalTabId = _data["generalTabId"];
            this.changedDate = _data["changedDate"] ? new Date(_data["changedDate"].toString()) : undefined as any;
            this.changedBy = _data["changedBy"];
            this.event = _data["event"];
            this.changedField = _data["changedField"];
            this.oldValue = _data["oldValue"];
            this.newValue = _data["newValue"];
        }
    }

    static fromJS(data: any): AuditLogEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityName"] = this.entityName;
        data["generalTabId"] = this.generalTabId;
        data["changedDate"] = this.changedDate ? this.changedDate.toISOString() : undefined as any;
        data["changedBy"] = this.changedBy;
        data["event"] = this.event;
        data["changedField"] = this.changedField;
        data["oldValue"] = this.oldValue;
        data["newValue"] = this.newValue;
        return data;
    }
}

export interface IAuditLogEntryDto {
    entityName?: string | undefined;
    generalTabId?: string;
    changedDate?: Date;
    changedBy?: string | undefined;
    event?: AuditEvent;
    changedField?: string | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;
}

export class ChangeActionitemStatusRequestDto implements IChangeActionitemStatusRequestDto {
    status?: ActionItemStatus;
    comment?: string | undefined;

    constructor(data?: IChangeActionitemStatusRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): ChangeActionitemStatusRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeActionitemStatusRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IChangeActionitemStatusRequestDto {
    status?: ActionItemStatus;
    comment?: string | undefined;
}

export class ChangeApprovalStateDto implements IChangeApprovalStateDto {
    targetState?: ApprovalState;
    approvalUserRole?: ApprovalUserRole;
    comment?: string | undefined;

    constructor(data?: IChangeApprovalStateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetState = _data["targetState"];
            this.approvalUserRole = _data["approvalUserRole"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): ChangeApprovalStateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeApprovalStateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetState"] = this.targetState;
        data["approvalUserRole"] = this.approvalUserRole;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IChangeApprovalStateDto {
    targetState?: ApprovalState;
    approvalUserRole?: ApprovalUserRole;
    comment?: string | undefined;
}

export class ColumnFilter implements IColumnFilter {
    field?: GeneralTabSortField;
    operator?: FilterOperator;
    value?: string | undefined;
    valueTo?: string | undefined;

    constructor(data?: IColumnFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["field"];
            this.operator = _data["operator"];
            this.value = _data["value"];
            this.valueTo = _data["valueTo"];
        }
    }

    static fromJS(data: any): ColumnFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ColumnFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field;
        data["operator"] = this.operator;
        data["value"] = this.value;
        data["valueTo"] = this.valueTo;
        return data;
    }
}

export interface IColumnFilter {
    field?: GeneralTabSortField;
    operator?: FilterOperator;
    value?: string | undefined;
    valueTo?: string | undefined;
}

export class CreateDistributionListDto implements ICreateDistributionListDto {
    reportType?: ReportType;
    title!: string;
    facility?: FacilityEnum;
    unit?: string | undefined;
    commonEmailsTo?: string | undefined;
    commonEmailsCc?: string | undefined;
    turnaroundEmailsTo?: string | undefined;
    creatorBackToBackEmail?: string | undefined;

    constructor(data?: ICreateDistributionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportType = _data["reportType"];
            this.title = _data["title"];
            this.facility = _data["facility"];
            this.unit = _data["unit"];
            this.commonEmailsTo = _data["commonEmailsTo"];
            this.commonEmailsCc = _data["commonEmailsCc"];
            this.turnaroundEmailsTo = _data["turnaroundEmailsTo"];
            this.creatorBackToBackEmail = _data["creatorBackToBackEmail"];
        }
    }

    static fromJS(data: any): CreateDistributionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDistributionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportType"] = this.reportType;
        data["title"] = this.title;
        data["facility"] = this.facility;
        data["unit"] = this.unit;
        data["commonEmailsTo"] = this.commonEmailsTo;
        data["commonEmailsCc"] = this.commonEmailsCc;
        data["turnaroundEmailsTo"] = this.turnaroundEmailsTo;
        data["creatorBackToBackEmail"] = this.creatorBackToBackEmail;
        return data;
    }
}

export interface ICreateDistributionListDto {
    reportType?: ReportType;
    title: string;
    facility?: FacilityEnum;
    unit?: string | undefined;
    commonEmailsTo?: string | undefined;
    commonEmailsCc?: string | undefined;
    turnaroundEmailsTo?: string | undefined;
    creatorBackToBackEmail?: string | undefined;
}

export class CreateRequest implements ICreateRequest {
    type?: ReferenceType;
    number?: string | undefined;

    constructor(data?: ICreateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.number = _data["number"];
        }
    }

    static fromJS(data: any): CreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["number"] = this.number;
        return data;
    }
}

export interface ICreateRequest {
    type?: ReferenceType;
    number?: string | undefined;
}

export class DamageMechanismDto implements IDamageMechanismDto {
    createdBy?: string | undefined;
    created?: Date | undefined;
    updatedBy?: string | undefined;
    updated?: Date | undefined;
    id?: string;
    readonly title?: string | undefined;
    code?: string | undefined;
    nameEn?: string | undefined;
    nameRu?: string | undefined;
    status?: GeneralStatus;
    type?: DamageMechanismType;

    constructor(data?: IDamageMechanismDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdBy = _data["createdBy"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updatedBy = _data["updatedBy"];
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.id = _data["id"];
            (this as any).title = _data["title"];
            this.code = _data["code"];
            this.nameEn = _data["nameEn"];
            this.nameRu = _data["nameRu"];
            this.status = _data["status"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): DamageMechanismDto {
        data = typeof data === 'object' ? data : {};
        let result = new DamageMechanismDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdBy"] = this.createdBy;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updatedBy"] = this.updatedBy;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["id"] = this.id;
        data["title"] = this.title;
        data["code"] = this.code;
        data["nameEn"] = this.nameEn;
        data["nameRu"] = this.nameRu;
        data["status"] = this.status;
        data["type"] = this.type;
        return data;
    }
}

export interface IDamageMechanismDto {
    createdBy?: string | undefined;
    created?: Date | undefined;
    updatedBy?: string | undefined;
    updated?: Date | undefined;
    id?: string;
    title?: string | undefined;
    code?: string | undefined;
    nameEn?: string | undefined;
    nameRu?: string | undefined;
    status?: GeneralStatus;
    type?: DamageMechanismType;
}

export enum DamageMechanismType {
    DamageMechanism = "DamageMechanism",
    FailureMode = "FailureMode",
}

export class DistributionList implements IDistributionList {
    id?: number;
    reportType?: ReportType;
    title?: string | undefined;
    facility?: FacilityEnum;
    unit?: string | undefined;
    commonEmailsTo?: string | undefined;
    commonEmailsCc?: string | undefined;
    turnaroundEmailsTo?: string | undefined;
    isActive?: boolean;
    creatorBackToBackEmail?: string | undefined;
    createdBy?: string;
    created?: Date;
    updatedBy?: string;
    updated?: Date;

    constructor(data?: IDistributionList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reportType = _data["reportType"];
            this.title = _data["title"];
            this.facility = _data["facility"];
            this.unit = _data["unit"];
            this.commonEmailsTo = _data["commonEmailsTo"];
            this.commonEmailsCc = _data["commonEmailsCc"];
            this.turnaroundEmailsTo = _data["turnaroundEmailsTo"];
            this.isActive = _data["isActive"];
            this.creatorBackToBackEmail = _data["creatorBackToBackEmail"];
            this.createdBy = _data["createdBy"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updatedBy = _data["updatedBy"];
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): DistributionList {
        data = typeof data === 'object' ? data : {};
        let result = new DistributionList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reportType"] = this.reportType;
        data["title"] = this.title;
        data["facility"] = this.facility;
        data["unit"] = this.unit;
        data["commonEmailsTo"] = this.commonEmailsTo;
        data["commonEmailsCc"] = this.commonEmailsCc;
        data["turnaroundEmailsTo"] = this.turnaroundEmailsTo;
        data["isActive"] = this.isActive;
        data["creatorBackToBackEmail"] = this.creatorBackToBackEmail;
        data["createdBy"] = this.createdBy;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updatedBy"] = this.updatedBy;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        return data;
    }
}

export interface IDistributionList {
    id?: number;
    reportType?: ReportType;
    title?: string | undefined;
    facility?: FacilityEnum;
    unit?: string | undefined;
    commonEmailsTo?: string | undefined;
    commonEmailsCc?: string | undefined;
    turnaroundEmailsTo?: string | undefined;
    isActive?: boolean;
    creatorBackToBackEmail?: string | undefined;
    createdBy?: string;
    created?: Date;
    updatedBy?: string;
    updated?: Date;
}

export class DistributionListTitleDto implements IDistributionListTitleDto {
    id?: number;
    title?: string | undefined;
    commonEmailsTo?: string | undefined;
    commonEmailsCc?: string | undefined;
    turnaroundEmailsTo?: string | undefined;

    constructor(data?: IDistributionListTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.commonEmailsTo = _data["commonEmailsTo"];
            this.commonEmailsCc = _data["commonEmailsCc"];
            this.turnaroundEmailsTo = _data["turnaroundEmailsTo"];
        }
    }

    static fromJS(data: any): DistributionListTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new DistributionListTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["commonEmailsTo"] = this.commonEmailsTo;
        data["commonEmailsCc"] = this.commonEmailsCc;
        data["turnaroundEmailsTo"] = this.turnaroundEmailsTo;
        return data;
    }
}

export interface IDistributionListTitleDto {
    id?: number;
    title?: string | undefined;
    commonEmailsTo?: string | undefined;
    commonEmailsCc?: string | undefined;
    turnaroundEmailsTo?: string | undefined;
}

export class E1EquipmentDto implements IE1EquipmentDto {
    id?: string;
    equipmentTag?: string | undefined;
    description?: string | undefined;
    equipmentClass?: string | undefined;
    equipmentSubclass?: string | undefined;
    integrityCriticality?: string | undefined;
    assetConsequence?: string | undefined;
    facility?: string | undefined;
    area?: string | undefined;
    unit?: string | undefined;
    equipmentStatus?: string | undefined;
    facilityDisplay?: string | undefined;
    areaDisplay?: string | undefined;
    classDisplay?: string | undefined;
    subclassDisplay?: string | undefined;
    unitDisplay?: string | undefined;

    constructor(data?: IE1EquipmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.equipmentTag = _data["equipmentTag"];
            this.description = _data["description"];
            this.equipmentClass = _data["equipmentClass"];
            this.equipmentSubclass = _data["equipmentSubclass"];
            this.integrityCriticality = _data["integrityCriticality"];
            this.assetConsequence = _data["assetConsequence"];
            this.facility = _data["facility"];
            this.area = _data["area"];
            this.unit = _data["unit"];
            this.equipmentStatus = _data["equipmentStatus"];
            this.facilityDisplay = _data["facilityDisplay"];
            this.areaDisplay = _data["areaDisplay"];
            this.classDisplay = _data["classDisplay"];
            this.subclassDisplay = _data["subclassDisplay"];
            this.unitDisplay = _data["unitDisplay"];
        }
    }

    static fromJS(data: any): E1EquipmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new E1EquipmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["equipmentTag"] = this.equipmentTag;
        data["description"] = this.description;
        data["equipmentClass"] = this.equipmentClass;
        data["equipmentSubclass"] = this.equipmentSubclass;
        data["integrityCriticality"] = this.integrityCriticality;
        data["assetConsequence"] = this.assetConsequence;
        data["facility"] = this.facility;
        data["area"] = this.area;
        data["unit"] = this.unit;
        data["equipmentStatus"] = this.equipmentStatus;
        data["facilityDisplay"] = this.facilityDisplay;
        data["areaDisplay"] = this.areaDisplay;
        data["classDisplay"] = this.classDisplay;
        data["subclassDisplay"] = this.subclassDisplay;
        data["unitDisplay"] = this.unitDisplay;
        return data;
    }
}

export interface IE1EquipmentDto {
    id?: string;
    equipmentTag?: string | undefined;
    description?: string | undefined;
    equipmentClass?: string | undefined;
    equipmentSubclass?: string | undefined;
    integrityCriticality?: string | undefined;
    assetConsequence?: string | undefined;
    facility?: string | undefined;
    area?: string | undefined;
    unit?: string | undefined;
    equipmentStatus?: string | undefined;
    facilityDisplay?: string | undefined;
    areaDisplay?: string | undefined;
    classDisplay?: string | undefined;
    subclassDisplay?: string | undefined;
    unitDisplay?: string | undefined;
}

export class E1EquipmentDtoInfiniteScrollResult implements IE1EquipmentDtoInfiniteScrollResult {
    items?: E1EquipmentDto[] | undefined;
    nextCursor?: string | undefined;
    hasMore?: boolean;
    count?: number;

    constructor(data?: IE1EquipmentDtoInfiniteScrollResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(E1EquipmentDto.fromJS(item));
            }
            this.nextCursor = _data["nextCursor"];
            this.hasMore = _data["hasMore"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): E1EquipmentDtoInfiniteScrollResult {
        data = typeof data === 'object' ? data : {};
        let result = new E1EquipmentDtoInfiniteScrollResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["nextCursor"] = this.nextCursor;
        data["hasMore"] = this.hasMore;
        data["count"] = this.count;
        return data;
    }
}

export interface IE1EquipmentDtoInfiniteScrollResult {
    items?: E1EquipmentDto[] | undefined;
    nextCursor?: string | undefined;
    hasMore?: boolean;
    count?: number;
}

export class EquipmentByTagResultDto implements IEquipmentByTagResultDto {
    id?: string | undefined;
    tagNumber?: string | undefined;
    description?: string | undefined;
    facility?: string | undefined;

    constructor(data?: IEquipmentByTagResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tagNumber = _data["tagNumber"];
            this.description = _data["description"];
            this.facility = _data["facility"];
        }
    }

    static fromJS(data: any): EquipmentByTagResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new EquipmentByTagResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tagNumber"] = this.tagNumber;
        data["description"] = this.description;
        data["facility"] = this.facility;
        return data;
    }
}

export interface IEquipmentByTagResultDto {
    id?: string | undefined;
    tagNumber?: string | undefined;
    description?: string | undefined;
    facility?: string | undefined;
}

export enum EquipmentProcessServiceEnum {
    AA_AceticAcid = "AA_AceticAcid",
    AA_ProcessAir = "AA_ProcessAir",
    AH_HydrochloricAcid = "AH_HydrochloricAcid",
    AI_InstrumentAir = "AI_InstrumentAir",
    AP_PhosphoricAcid = "AP_PhosphoricAcid",
    AP_UtilityAirPlantAir = "AP_UtilityAirPlantAir",
    BB_BoilerBlowdown = "BB_BoilerBlowdown",
    BD_BlowdownHydrocarbons = "BD_BlowdownHydrocarbons",
    BF_FlareGas = "BF_FlareGas",
    BFC_FlareGasCold = "BFC_FlareGasCold",
    BFH_FlareGasHighPressure = "BFH_FlareGasHighPressure",
    BFL_FlareGasLowPressure = "BFL_FlareGasLowPressure",
    BFU_FlueGasToStack = "BFU_FlueGasToStack",
    BFV_ClosedVentSystem = "BFV_ClosedVentSystem",
    BKW_BackWashWater = "BKW_BackWashWater",
    BKW_18_BackwashWaterTreatedWater = "BKW_18_BackwashWaterTreatedWater",
    BKW_33_BackwashWaterRORejectWater = "BKW_33_BackwashWaterRORejectWater",
    BWD_33_BackwashDrain = "BWD_33_BackwashDrain",
    BV_VentToAtmosphere = "BV_VentToAtmosphere",
    CBD_06_ContinuousBlowdown = "CBD_06_ContinuousBlowdown",
    CBD_24_ContinuousBlowdown = "CBD_24_ContinuousBlowdown",
    CC_SpentCaustic = "CC_SpentCaustic",
    CC_CausticAndCatalyst = "CC_CausticAndCatalyst",
    CCB_SodiumChlorideBrine = "CCB_SodiumChlorideBrine",
    CCB_33_Brine = "CCB_33_Brine",
    CCC_CalciumChloride = "CCC_CalciumChloride",
    CCD_DemulsifyingAgent = "CCD_DemulsifyingAgent",
    CCS_Caustic = "CCS_Caustic",
    CD_13_ChemicalDosing = "CD_13_ChemicalDosing",
    CDE_AmineLean = "CDE_AmineLean",
    CDF_AmineFreshLean = "CDF_AmineFreshLean",
    CDM_AmineRich = "CDM_AmineRich",
    CF_FoamMixture = "CF_FoamMixture",
    CFA_AntiFoam = "CFA_AntiFoam",
    CFC_FerricChloride = "CFC_FerricChloride",
    CH_HydrazineSolution = "CH_HydrazineSolution",
    CHM_BiologicalNutrients = "CHM_BiologicalNutrients",
    CI_ChemicalInhibitorAndAntiscale = "CI_ChemicalInhibitorAndAntiscale",
    CLW_18_CoolingWaterTreatedWater = "CLW_18_CoolingWaterTreatedWater",
    CO_CarbonDioxide = "CO_CarbonDioxide",
    CPE_Polyelectrolyte = "CPE_Polyelectrolyte",
    CS_Sulphur = "CS_Sulphur",
    CS_SpentCaustic = "CS_SpentCaustic",
    CSB_SodiumBisulphite = "CSB_SodiumBisulphite",
    CSN_SodiumHypochlorite = "CSN_SodiumHypochlorite",
    CSO_SodiumSulphate = "CSO_SodiumSulphate",
    DCS_DrainCaustic = "DCS_DrainCaustic",
    DC_ClosedDrains = "DC_ClosedDrains",
    DFX_FlexsorbDrainsSlop = "DFX_FlexsorbDrainsSlop",
    DHC_DrainHydrocarbons = "DHC_DrainHydrocarbons",
    DMD_SlopMethanolDEA = "DMD_SlopMethanolDEA",
    DOL_DrainOilySewerOpen = "DOL_DrainOilySewerOpen",
    DO_OpenDrains = "DO_OpenDrains",
    DRA_ChemicalDrainOpen = "DRA_ChemicalDrainOpen",
    DS_SanitarySewer = "DS_SanitarySewer",
    DSL_DieselFuel = "DSL_DieselFuel",
    DW_WasteCondensate = "DW_WasteCondensate",
    D_33_Drain = "D_33_Drain",
    EG_EthyleneGlycol = "EG_EthyleneGlycol",
    FFCC_FireProtectionFoamConcentrate = "FFCC_FireProtectionFoamConcentrate",
    FG_FuelGas = "FG_FuelGas",
    FG_05_FuelGasButaneGas = "FG_05_FuelGasButaneGas",
    FGH_FuelGasHighPressure = "FGH_FuelGasHighPressure",
    FL_DieselFuelRefOnlyDoNotUse = "FL_DieselFuelRefOnlyDoNotUse",
    FM_Methanol = "FM_Methanol",
    FMP_MethanolPure = "FMP_MethanolPure",
    FSG_FireSuppressionGas = "FSG_FireSuppressionGas",
    FSS_FireFightingSystemPowder = "FSS_FireFightingSystemPowder",
    GCL_ClausGas = "GCL_ClausGas",
    GDE_DesulphurisedGas = "GDE_DesulphurisedGas",
    GHV_HydrocarbonVapour = "GHV_HydrocarbonVapour",
    GI_Nitrogen = "GI_Nitrogen",
    GP_GasPurge = "GP_GasPurge",
    GRC_RecycleGas = "GRC_RecycleGas",
    GRG_RichGas = "GRG_RichGas",
    GRI_ReactorInletGas = "GRI_ReactorInletGas",
    GRK_ReactorOffGas = "GRK_ReactorOffGas",
    GS_SourGas = "GS_SourGas",
    GSA_EmergencyOffGas = "GSA_EmergencyOffGas",
    GSL_SalesGas = "GSL_SalesGas",
    GST_TailGas = "GST_TailGas",
    GW_WasteGasOffGas = "GW_WasteGasOffGas",
    HOR_HydraulicOilReturn = "HOR_HydraulicOilReturn",
    HOS_HydraulicOilSupply = "HOS_HydraulicOilSupply",
    HS_08_HeatingSteam = "HS_08_HeatingSteam",
    IA_12_InstrumentAir = "IA_12_InstrumentAir",
    IBD_19_IntermittentBlowdown = "IBD_19_IntermittentBlowdown",
    MF_02_MinimumFlow = "MF_02_MinimumFlow",
    ML_Mud = "ML_Mud",
    MPS_32_MediumPressureSteam = "MPS_32_MediumPressureSteam",
    MUW_17_MakeUpWater = "MUW_17_MakeUpWater",
    N_28_Nitrogen = "N_28_Nitrogen",
    NH_NitrogenHighPressure = "NH_NitrogenHighPressure",
    NL_NitrogenLowPressure = "NL_NitrogenLowPressure",
    PA_15_PurgeAirMultiMediaFilters = "PA_15_PurgeAirMultiMediaFilters",
    PB_BroadFraction = "PB_BroadFraction",
    PBT_Butane = "PBT_Butane",
    PE_ProcessEffluent = "PE_ProcessEffluent",
    PE_Ethane = "PE_Ethane",
    PFC_ProtectionFireCO2 = "PFC_ProtectionFireCO2",
    PGC_GasCondensate = "PGC_GasCondensate",
    PHC_ProcessHydrocarbons = "PHC_ProcessHydrocarbons",
    PL_ProcessLiquid = "PL_ProcessLiquid",
    PLA_16_PlantAir = "PLA_16_PlantAir",
    PLM_OilMist = "PLM_OilMist",
    PME_MethaneDryGas = "PME_MethaneDryGas",
    PP_Propane = "PP_Propane",
    PSE_SolventExtract = "PSE_SolventExtract",
    SD_SiltDrainage = "SD_SiltDrainage",
    SG_SealGas = "SG_SealGas",
    SH_SteamHighPressure = "SH_SteamHighPressure",
    SHM_SteamHighMediumPressureSulphurOnly = "SHM_SteamHighMediumPressureSulphurOnly",
    SI_SteamIntermediatePressure = "SI_SteamIntermediatePressure",
    SL_SteamLowPressure = "SL_SteamLowPressure",
    SLL_SteamLowLowPressure = "SLL_SteamLowLowPressure",
    SM_SteamMediumPressure = "SM_SteamMediumPressure",
    SR_SteamReducedPressure = "SR_SteamReducedPressure",
    ST_SteamTracer = "ST_SteamTracer",
    SVL_SteamVeryLowPressure = "SVL_SteamVeryLowPressure",
    SU_24_SamplingUnitUtilityWater = "SU_24_SamplingUnitUtilityWater",
    T_CondensateExport = "T_CondensateExport",
    TH_CondensateHighPressure = "TH_CondensateHighPressure",
    THM_CondensateHighMediumPressureSulphurOnly = "THM_CondensateHighMediumPressureSulphurOnly",
    TI_CondensateIntermediatePressure = "TI_CondensateIntermediatePressure",
    TL_CondensateLowPressure = "TL_CondensateLowPressure",
    TLL_CondensateExtraLowPressure = "TLL_CondensateExtraLowPressure",
    TM_CondensateMediumPressure = "TM_CondensateMediumPressure",
    TR_CondensateProcess = "TR_CondensateProcess",
    TRM_VesselTrimRefOnlyDoNotUse = "TRM_VesselTrimRefOnlyDoNotUse",
    TVL_CondensateVeryLowPressure = "TVL_CondensateVeryLowPressure",
    TW_18_TreatedWaterROProduct = "TW_18_TreatedWaterROProduct",
    TX_CondensateFromDistributor = "TX_CondensateFromDistributor",
    U_CompressedWetAir = "U_CompressedWetAir",
    V_VentToAtmosphereRefOnlyDoNotUse = "V_VentToAtmosphereRefOnlyDoNotUse",
    V_34_VentToAtmosphereRefOnlyDoNotUse = "V_34_VentToAtmosphereRefOnlyDoNotUse",
    VB_BreathingAir = "VB_BreathingAir",
    VCB_CombustionAir = "VCB_CombustionAir",
    VE_ExhaustAir = "VE_ExhaustAir",
    VI_InstrumentAir = "VI_InstrumentAir",
    VH_InstrumentAirHighPressure = "VH_InstrumentAirHighPressure",
    VO_Oxygen = "VO_Oxygen",
    VP_ProcessAir = "VP_ProcessAir",
    VT_VesselTrim = "VT_VesselTrim",
    VV_UtilityAirPlantAir = "VV_UtilityAirPlantAir",
    W_BoilerFeedWaterHighPressure = "W_BoilerFeedWaterHighPressure",
    WBL_BoilerFeedWaterLowPressure = "WBL_BoilerFeedWaterLowPressure",
    WC_ChilledWaterSupply = "WC_ChilledWaterSupply",
    WCR_ChilledWaterReturn = "WCR_ChilledWaterReturn",
    WCS_CoolingWaterSupply = "WCS_CoolingWaterSupply",
    WD_PotableWater = "WD_PotableWater",
    WDM_DemineralisedWater = "WDM_DemineralisedWater",
    WE_EffluentWater = "WE_EffluentWater",
    WF_FireFightingWater = "WF_FireFightingWater",
    WH_HotWaterReturnInternalLoop = "WH_HotWaterReturnInternalLoop",
    WHR_HotWaterReturn = "WHR_HotWaterReturn",
    WHS_HotWaterSupply = "WHS_HotWaterSupply",
    WI_HotWaterSupplyInternalLoop = "WI_HotWaterSupplyInternalLoop",
    WM_MakeUpWater = "WM_MakeUpWater",
    WO_OilyWater = "WO_OilyWater",
    WP_ProcessWater = "WP_ProcessWater",
    WPS_ProcessWaterGasLiquidStripped = "WPS_ProcessWaterGasLiquidStripped",
    WR_CoolingWaterReturn = "WR_CoolingWaterReturn",
    WRA_RawWater = "WRA_RawWater",
    WRA_33_RawWater = "WRA_33_RawWater",
    WRF_33_FilteredRawWater = "WRF_33_FilteredRawWater",
    WRS_33_SoftenedRawWater = "WRS_33_SoftenedRawWater",
    WS_ContaminatedSurfaceWater = "WS_ContaminatedSurfaceWater",
    WSR_SourWater = "WSR_SourWater",
    WT_TreatedWaterPolishedCondensate = "WT_TreatedWaterPolishedCondensate",
    WU_UtilityWater = "WU_UtilityWater",
    WUT_HotWaterTracingReturn = "WUT_HotWaterTracingReturn",
    WX_HotWaterReturnTracing = "WX_HotWaterReturnTracing",
}

export enum EquipmentSafeguard {
    Unknown = "Unknown",
    Yes = "Yes",
    No = "No",
}

export enum EquipmentSource {
    E1 = "E1",
    Predix = "Predix",
}

export class EquipmentTabDto implements IEquipmentTabDto {
    id?: number;
    facility?: string | undefined;
    area?: string | undefined;
    taskFrequency?: TaskFrequency;
    percentOverdue?: PercentOverdue;
    assignedManagementAuthorizationLevel?: AMALType;
    facilityOwnerId?: string | undefined;
    facilityOwner?: FacilityOwnerDto;
    consequenceRanking?: string | undefined;
    standbyMode?: boolean | undefined;
    isEquipmentSafeguard?: EquipmentSafeguard;
    justification?: string | undefined;
    reportType?: ReportType;
    additionalInformationForEquipmentEN?: string | undefined;
    additionalInformationForEquipmentRU?: string | undefined;
    additionalInformationForEquipmentKZ?: string | undefined;
    generalTabId?: string;
    e1DataEquipments?: E1EquipmentDto[] | undefined;
    predixDataEquipments?: GePredixEquipmentDto[] | undefined;

    constructor(data?: IEquipmentTabDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.facility = _data["facility"];
            this.area = _data["area"];
            this.taskFrequency = _data["taskFrequency"];
            this.percentOverdue = _data["percentOverdue"];
            this.assignedManagementAuthorizationLevel = _data["assignedManagementAuthorizationLevel"];
            this.facilityOwnerId = _data["facilityOwnerId"];
            this.facilityOwner = _data["facilityOwner"] ? FacilityOwnerDto.fromJS(_data["facilityOwner"]) : undefined as any;
            this.consequenceRanking = _data["consequenceRanking"];
            this.standbyMode = _data["standbyMode"];
            this.isEquipmentSafeguard = _data["isEquipmentSafeguard"];
            this.justification = _data["justification"];
            this.reportType = _data["reportType"];
            this.additionalInformationForEquipmentEN = _data["additionalInformationForEquipmentEN"];
            this.additionalInformationForEquipmentRU = _data["additionalInformationForEquipmentRU"];
            this.additionalInformationForEquipmentKZ = _data["additionalInformationForEquipmentKZ"];
            this.generalTabId = _data["generalTabId"];
            if (Array.isArray(_data["e1DataEquipments"])) {
                this.e1DataEquipments = [] as any;
                for (let item of _data["e1DataEquipments"])
                    this.e1DataEquipments!.push(E1EquipmentDto.fromJS(item));
            }
            if (Array.isArray(_data["predixDataEquipments"])) {
                this.predixDataEquipments = [] as any;
                for (let item of _data["predixDataEquipments"])
                    this.predixDataEquipments!.push(GePredixEquipmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EquipmentTabDto {
        data = typeof data === 'object' ? data : {};
        let result = new EquipmentTabDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["facility"] = this.facility;
        data["area"] = this.area;
        data["taskFrequency"] = this.taskFrequency;
        data["percentOverdue"] = this.percentOverdue;
        data["assignedManagementAuthorizationLevel"] = this.assignedManagementAuthorizationLevel;
        data["facilityOwnerId"] = this.facilityOwnerId;
        data["facilityOwner"] = this.facilityOwner ? this.facilityOwner.toJSON() : undefined as any;
        data["consequenceRanking"] = this.consequenceRanking;
        data["standbyMode"] = this.standbyMode;
        data["isEquipmentSafeguard"] = this.isEquipmentSafeguard;
        data["justification"] = this.justification;
        data["reportType"] = this.reportType;
        data["additionalInformationForEquipmentEN"] = this.additionalInformationForEquipmentEN;
        data["additionalInformationForEquipmentRU"] = this.additionalInformationForEquipmentRU;
        data["additionalInformationForEquipmentKZ"] = this.additionalInformationForEquipmentKZ;
        data["generalTabId"] = this.generalTabId;
        if (Array.isArray(this.e1DataEquipments)) {
            data["e1DataEquipments"] = [];
            for (let item of this.e1DataEquipments)
                data["e1DataEquipments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.predixDataEquipments)) {
            data["predixDataEquipments"] = [];
            for (let item of this.predixDataEquipments)
                data["predixDataEquipments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEquipmentTabDto {
    id?: number;
    facility?: string | undefined;
    area?: string | undefined;
    taskFrequency?: TaskFrequency;
    percentOverdue?: PercentOverdue;
    assignedManagementAuthorizationLevel?: AMALType;
    facilityOwnerId?: string | undefined;
    facilityOwner?: FacilityOwnerDto;
    consequenceRanking?: string | undefined;
    standbyMode?: boolean | undefined;
    isEquipmentSafeguard?: EquipmentSafeguard;
    justification?: string | undefined;
    reportType?: ReportType;
    additionalInformationForEquipmentEN?: string | undefined;
    additionalInformationForEquipmentRU?: string | undefined;
    additionalInformationForEquipmentKZ?: string | undefined;
    generalTabId?: string;
    e1DataEquipments?: E1EquipmentDto[] | undefined;
    predixDataEquipments?: GePredixEquipmentDto[] | undefined;
}

export enum ExportFormat {
    Excel = "Excel",
    Word = "Word",
    Pdf = "Pdf",
}

export enum FDMStatus {
    PreparationInProgress = "PreparationInProgress",
    ExecutionInProgress = "ExecutionInProgress",
    Closed = "Closed",
    Cancelled = "Cancelled",
    OutOfService = "OutOfService",
}

export enum FFSResultType {
    Passed = "Passed",
    Failed = "Failed",
    NotAvailable = "NotAvailable",
}

export enum FFSType {
    NotAvailable = "NotAvailable",
    No = "No",
    FFS1 = "FFS1",
    FFS2 = "FFS2",
    FFS3 = "FFS3",
}

export enum FacilityEnum {
    TS = "TS",
    AFM = "AFM",
    EXP = "EXP",
    FGP = "FGP",
    Field = "Field",
    IOC = "IOC",
    KTL = "KTL",
    NonProductionFacility = "NonProductionFacility",
    NotAssigned = "NotAssigned",
    Power = "Power",
    SGISGP = "SGISGP",
    TengizFacilitiesMaintenance = "TengizFacilitiesMaintenance",
    TMF = "TMF",
    Utilities = "Utilities",
}

export class FacilityOptionDto implements IFacilityOptionDto {
    value?: string | undefined;
    displayName?: string | undefined;

    constructor(data?: IFacilityOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): FacilityOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FacilityOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IFacilityOptionDto {
    value?: string | undefined;
    displayName?: string | undefined;
}

export class FacilityOwnerDto implements IFacilityOwnerDto {
    createdBy?: string | undefined;
    created?: Date | undefined;
    updatedBy?: string | undefined;
    updated?: Date | undefined;
    id?: string;
    name?: string | undefined;
    sharedEmail?: string | undefined;
    facility?: FacilityEnum;
    status?: GeneralStatus;

    constructor(data?: IFacilityOwnerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdBy = _data["createdBy"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updatedBy = _data["updatedBy"];
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.id = _data["id"];
            this.name = _data["name"];
            this.sharedEmail = _data["sharedEmail"];
            this.facility = _data["facility"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): FacilityOwnerDto {
        data = typeof data === 'object' ? data : {};
        let result = new FacilityOwnerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdBy"] = this.createdBy;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updatedBy"] = this.updatedBy;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["id"] = this.id;
        data["name"] = this.name;
        data["sharedEmail"] = this.sharedEmail;
        data["facility"] = this.facility;
        data["status"] = this.status;
        return data;
    }
}

export interface IFacilityOwnerDto {
    createdBy?: string | undefined;
    created?: Date | undefined;
    updatedBy?: string | undefined;
    updated?: Date | undefined;
    id?: string;
    name?: string | undefined;
    sharedEmail?: string | undefined;
    facility?: FacilityEnum;
    status?: GeneralStatus;
}

export class FdmEventDto implements IFdmEventDto {
    currentState?: string | undefined;
    actionItemStatus?: string | undefined;
    created?: Date;
    createdBy?: string | undefined;
    comment?: string | undefined;
    type?: string | undefined;

    constructor(data?: IFdmEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentState = _data["currentState"];
            this.actionItemStatus = _data["actionItemStatus"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.comment = _data["comment"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): FdmEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new FdmEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentState"] = this.currentState;
        data["actionItemStatus"] = this.actionItemStatus;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["comment"] = this.comment;
        data["type"] = this.type;
        return data;
    }
}

export interface IFdmEventDto {
    currentState?: string | undefined;
    actionItemStatus?: string | undefined;
    created?: Date;
    createdBy?: string | undefined;
    comment?: string | undefined;
    type?: string | undefined;
}

export enum FilterOperator {
    Eq = "eq",
    Neq = "neq",
    Gt = "gt",
    Gte = "gte",
    Lt = "lt",
    Lte = "lte",
    Contains = "contains",
    Ncontains = "ncontains",
    Startswith = "startswith",
    Nstartswith = "nstartswith",
    Endswith = "endswith",
    Nendswith = "nendswith",
    Isnull = "isnull",
    Isnotnull = "isnotnull",
    Between = "between",
}

export class FindingDescriptionTabDto implements IFindingDescriptionTabDto {
    id?: number;
    generalTabId?: string;
    descriptionOfConditionEn?: string | undefined;
    descriptionOfConditionRu?: string | undefined;
    descriptionOfConditionKz?: string | undefined;
    riskScenarioDescriptionEn?: string | undefined;
    riskScenarioDescriptionRu?: string | undefined;
    riskScenarioDescriptionKz?: string | undefined;
    implementedSafeguardsDescriptionEn?: string | undefined;
    implementedSafeguardsDescriptionRu?: string | undefined;
    implementedSafeguardsDescriptionKz?: string | undefined;
    assetShutdown?: boolean | undefined;
    concernsEn?: string | undefined;
    concernsRu?: string | undefined;
    concernsKz?: string | undefined;
    recomendedResolutionEn?: string | undefined;
    recomendedResolutionRu?: string | undefined;
    recomendedResolutionKz?: string | undefined;
    needMitigation?: boolean | undefined;
    recomendedMitigationEn?: string | undefined;
    recomendedMitigationRu?: string | undefined;
    recomendedMitigationKz?: string | undefined;

    constructor(data?: IFindingDescriptionTabDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.generalTabId = _data["generalTabId"];
            this.descriptionOfConditionEn = _data["descriptionOfConditionEn"];
            this.descriptionOfConditionRu = _data["descriptionOfConditionRu"];
            this.descriptionOfConditionKz = _data["descriptionOfConditionKz"];
            this.riskScenarioDescriptionEn = _data["riskScenarioDescriptionEn"];
            this.riskScenarioDescriptionRu = _data["riskScenarioDescriptionRu"];
            this.riskScenarioDescriptionKz = _data["riskScenarioDescriptionKz"];
            this.implementedSafeguardsDescriptionEn = _data["implementedSafeguardsDescriptionEn"];
            this.implementedSafeguardsDescriptionRu = _data["implementedSafeguardsDescriptionRu"];
            this.implementedSafeguardsDescriptionKz = _data["implementedSafeguardsDescriptionKz"];
            this.assetShutdown = _data["assetShutdown"];
            this.concernsEn = _data["concernsEn"];
            this.concernsRu = _data["concernsRu"];
            this.concernsKz = _data["concernsKz"];
            this.recomendedResolutionEn = _data["recomendedResolutionEn"];
            this.recomendedResolutionRu = _data["recomendedResolutionRu"];
            this.recomendedResolutionKz = _data["recomendedResolutionKz"];
            this.needMitigation = _data["needMitigation"];
            this.recomendedMitigationEn = _data["recomendedMitigationEn"];
            this.recomendedMitigationRu = _data["recomendedMitigationRu"];
            this.recomendedMitigationKz = _data["recomendedMitigationKz"];
        }
    }

    static fromJS(data: any): FindingDescriptionTabDto {
        data = typeof data === 'object' ? data : {};
        let result = new FindingDescriptionTabDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["generalTabId"] = this.generalTabId;
        data["descriptionOfConditionEn"] = this.descriptionOfConditionEn;
        data["descriptionOfConditionRu"] = this.descriptionOfConditionRu;
        data["descriptionOfConditionKz"] = this.descriptionOfConditionKz;
        data["riskScenarioDescriptionEn"] = this.riskScenarioDescriptionEn;
        data["riskScenarioDescriptionRu"] = this.riskScenarioDescriptionRu;
        data["riskScenarioDescriptionKz"] = this.riskScenarioDescriptionKz;
        data["implementedSafeguardsDescriptionEn"] = this.implementedSafeguardsDescriptionEn;
        data["implementedSafeguardsDescriptionRu"] = this.implementedSafeguardsDescriptionRu;
        data["implementedSafeguardsDescriptionKz"] = this.implementedSafeguardsDescriptionKz;
        data["assetShutdown"] = this.assetShutdown;
        data["concernsEn"] = this.concernsEn;
        data["concernsRu"] = this.concernsRu;
        data["concernsKz"] = this.concernsKz;
        data["recomendedResolutionEn"] = this.recomendedResolutionEn;
        data["recomendedResolutionRu"] = this.recomendedResolutionRu;
        data["recomendedResolutionKz"] = this.recomendedResolutionKz;
        data["needMitigation"] = this.needMitigation;
        data["recomendedMitigationEn"] = this.recomendedMitigationEn;
        data["recomendedMitigationRu"] = this.recomendedMitigationRu;
        data["recomendedMitigationKz"] = this.recomendedMitigationKz;
        return data;
    }
}

export interface IFindingDescriptionTabDto {
    id?: number;
    generalTabId?: string;
    descriptionOfConditionEn?: string | undefined;
    descriptionOfConditionRu?: string | undefined;
    descriptionOfConditionKz?: string | undefined;
    riskScenarioDescriptionEn?: string | undefined;
    riskScenarioDescriptionRu?: string | undefined;
    riskScenarioDescriptionKz?: string | undefined;
    implementedSafeguardsDescriptionEn?: string | undefined;
    implementedSafeguardsDescriptionRu?: string | undefined;
    implementedSafeguardsDescriptionKz?: string | undefined;
    assetShutdown?: boolean | undefined;
    concernsEn?: string | undefined;
    concernsRu?: string | undefined;
    concernsKz?: string | undefined;
    recomendedResolutionEn?: string | undefined;
    recomendedResolutionRu?: string | undefined;
    recomendedResolutionKz?: string | undefined;
    needMitigation?: boolean | undefined;
    recomendedMitigationEn?: string | undefined;
    recomendedMitigationRu?: string | undefined;
    recomendedMitigationKz?: string | undefined;
}

export enum FindingType {
    Failed = "Failed",
    StaticCondition = "StaticCondition",
    TimeDependentCondition = "TimeDependentCondition",
}

export class GePredixEquipmentDto implements IGePredixEquipmentDto {
    id?: string;
    equipmentTag?: string | undefined;
    descriptionEn?: string | undefined;
    integrityConsequence?: string | undefined;
    assetConsequence?: string | undefined;
    gePredixEquipmentType?: string | undefined;
    gePredixPlant?: string | undefined;
    gePredixUnit?: string | undefined;
    area?: string | undefined;

    constructor(data?: IGePredixEquipmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.equipmentTag = _data["equipmentTag"];
            this.descriptionEn = _data["descriptionEn"];
            this.integrityConsequence = _data["integrityConsequence"];
            this.assetConsequence = _data["assetConsequence"];
            this.gePredixEquipmentType = _data["gePredixEquipmentType"];
            this.gePredixPlant = _data["gePredixPlant"];
            this.gePredixUnit = _data["gePredixUnit"];
            this.area = _data["area"];
        }
    }

    static fromJS(data: any): GePredixEquipmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new GePredixEquipmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["equipmentTag"] = this.equipmentTag;
        data["descriptionEn"] = this.descriptionEn;
        data["integrityConsequence"] = this.integrityConsequence;
        data["assetConsequence"] = this.assetConsequence;
        data["gePredixEquipmentType"] = this.gePredixEquipmentType;
        data["gePredixPlant"] = this.gePredixPlant;
        data["gePredixUnit"] = this.gePredixUnit;
        data["area"] = this.area;
        return data;
    }
}

export interface IGePredixEquipmentDto {
    id?: string;
    equipmentTag?: string | undefined;
    descriptionEn?: string | undefined;
    integrityConsequence?: string | undefined;
    assetConsequence?: string | undefined;
    gePredixEquipmentType?: string | undefined;
    gePredixPlant?: string | undefined;
    gePredixUnit?: string | undefined;
    area?: string | undefined;
}

export class GePredixEquipmentDtoInfiniteScrollResult implements IGePredixEquipmentDtoInfiniteScrollResult {
    items?: GePredixEquipmentDto[] | undefined;
    nextCursor?: string | undefined;
    hasMore?: boolean;
    count?: number;

    constructor(data?: IGePredixEquipmentDtoInfiniteScrollResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GePredixEquipmentDto.fromJS(item));
            }
            this.nextCursor = _data["nextCursor"];
            this.hasMore = _data["hasMore"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GePredixEquipmentDtoInfiniteScrollResult {
        data = typeof data === 'object' ? data : {};
        let result = new GePredixEquipmentDtoInfiniteScrollResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["nextCursor"] = this.nextCursor;
        data["hasMore"] = this.hasMore;
        data["count"] = this.count;
        return data;
    }
}

export interface IGePredixEquipmentDtoInfiniteScrollResult {
    items?: GePredixEquipmentDto[] | undefined;
    nextCursor?: string | undefined;
    hasMore?: boolean;
    count?: number;
}

export enum GeneralStatus {
    Active = "Active",
    Inactive = "Inactive",
}

export class GeneralTabDto implements IGeneralTabDto {
    id?: string;
    uniqueId?: string | undefined;
    revisions?: string | undefined;
    waitingFor?: string | undefined;
    reportTitleEn?: string | undefined;
    reportTitleRu?: string | undefined;
    reportTitleKz?: string | undefined;
    reportType?: ReportType;
    isPowerApp?: boolean;
    initiator?: string | undefined;
    owner?: string | undefined;
    closedOn?: Date | undefined;
    resolutionTargetDate?: Date | undefined;
    resolutionDateExplanation?: string | undefined;
    deviationFoundDate?: Date | undefined;
    descriptionEn?: string | undefined;
    descriptionRu?: string | undefined;
    descriptionKz?: string | undefined;
    discipline?: string | undefined;
    findingType?: FindingType;
    retirementDate?: Date;
    ffsPerformed?: FFSType;
    ffsResult?: FFSResultType;
    shutDownRequired?: ShutDownType;
    movedTo?: string | undefined;
    damageMechanisms?: DamageMechanismDto[] | undefined;
    value?: number;
    barrelsOfOilEquivalent?: number;
    tonsOfOilEquivalent?: number;
    currentState?: ApprovalState;
    currentFDMStatus?: FDMStatus;
    created?: Date;
    daysForApproval?: number | undefined;
    planApprovalDueDate?: Date | undefined;
    planApprovalDueSoon?: boolean;

    constructor(data?: IGeneralTabDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.uniqueId = _data["uniqueId"];
            this.revisions = _data["revisions"];
            this.waitingFor = _data["waitingFor"];
            this.reportTitleEn = _data["reportTitleEn"];
            this.reportTitleRu = _data["reportTitleRu"];
            this.reportTitleKz = _data["reportTitleKz"];
            this.reportType = _data["reportType"];
            this.isPowerApp = _data["isPowerApp"];
            this.initiator = _data["initiator"];
            this.owner = _data["owner"];
            this.closedOn = _data["closedOn"] ? new Date(_data["closedOn"].toString()) : undefined as any;
            this.resolutionTargetDate = _data["resolutionTargetDate"] ? new Date(_data["resolutionTargetDate"].toString()) : undefined as any;
            this.resolutionDateExplanation = _data["resolutionDateExplanation"];
            this.deviationFoundDate = _data["deviationFoundDate"] ? new Date(_data["deviationFoundDate"].toString()) : undefined as any;
            this.descriptionEn = _data["descriptionEn"];
            this.descriptionRu = _data["descriptionRu"];
            this.descriptionKz = _data["descriptionKz"];
            this.discipline = _data["discipline"];
            this.findingType = _data["findingType"];
            this.retirementDate = _data["retirementDate"] ? new Date(_data["retirementDate"].toString()) : undefined as any;
            this.ffsPerformed = _data["ffsPerformed"];
            this.ffsResult = _data["ffsResult"];
            this.shutDownRequired = _data["shutDownRequired"];
            this.movedTo = _data["movedTo"];
            if (Array.isArray(_data["damageMechanisms"])) {
                this.damageMechanisms = [] as any;
                for (let item of _data["damageMechanisms"])
                    this.damageMechanisms!.push(DamageMechanismDto.fromJS(item));
            }
            this.value = _data["value"];
            this.barrelsOfOilEquivalent = _data["barrelsOfOilEquivalent"];
            this.tonsOfOilEquivalent = _data["tonsOfOilEquivalent"];
            this.currentState = _data["currentState"];
            this.currentFDMStatus = _data["currentFDMStatus"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.daysForApproval = _data["daysForApproval"];
            this.planApprovalDueDate = _data["planApprovalDueDate"] ? new Date(_data["planApprovalDueDate"].toString()) : undefined as any;
            this.planApprovalDueSoon = _data["planApprovalDueSoon"];
        }
    }

    static fromJS(data: any): GeneralTabDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralTabDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["uniqueId"] = this.uniqueId;
        data["revisions"] = this.revisions;
        data["waitingFor"] = this.waitingFor;
        data["reportTitleEn"] = this.reportTitleEn;
        data["reportTitleRu"] = this.reportTitleRu;
        data["reportTitleKz"] = this.reportTitleKz;
        data["reportType"] = this.reportType;
        data["isPowerApp"] = this.isPowerApp;
        data["initiator"] = this.initiator;
        data["owner"] = this.owner;
        data["closedOn"] = this.closedOn ? this.closedOn.toISOString() : undefined as any;
        data["resolutionTargetDate"] = this.resolutionTargetDate ? this.resolutionTargetDate.toISOString() : undefined as any;
        data["resolutionDateExplanation"] = this.resolutionDateExplanation;
        data["deviationFoundDate"] = this.deviationFoundDate ? this.deviationFoundDate.toISOString() : undefined as any;
        data["descriptionEn"] = this.descriptionEn;
        data["descriptionRu"] = this.descriptionRu;
        data["descriptionKz"] = this.descriptionKz;
        data["discipline"] = this.discipline;
        data["findingType"] = this.findingType;
        data["retirementDate"] = this.retirementDate ? this.retirementDate.toISOString() : undefined as any;
        data["ffsPerformed"] = this.ffsPerformed;
        data["ffsResult"] = this.ffsResult;
        data["shutDownRequired"] = this.shutDownRequired;
        data["movedTo"] = this.movedTo;
        if (Array.isArray(this.damageMechanisms)) {
            data["damageMechanisms"] = [];
            for (let item of this.damageMechanisms)
                data["damageMechanisms"].push(item ? item.toJSON() : undefined as any);
        }
        data["value"] = this.value;
        data["barrelsOfOilEquivalent"] = this.barrelsOfOilEquivalent;
        data["tonsOfOilEquivalent"] = this.tonsOfOilEquivalent;
        data["currentState"] = this.currentState;
        data["currentFDMStatus"] = this.currentFDMStatus;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["daysForApproval"] = this.daysForApproval;
        data["planApprovalDueDate"] = this.planApprovalDueDate ? this.planApprovalDueDate.toISOString() : undefined as any;
        data["planApprovalDueSoon"] = this.planApprovalDueSoon;
        return data;
    }
}

export interface IGeneralTabDto {
    id?: string;
    uniqueId?: string | undefined;
    revisions?: string | undefined;
    waitingFor?: string | undefined;
    reportTitleEn?: string | undefined;
    reportTitleRu?: string | undefined;
    reportTitleKz?: string | undefined;
    reportType?: ReportType;
    isPowerApp?: boolean;
    initiator?: string | undefined;
    owner?: string | undefined;
    closedOn?: Date | undefined;
    resolutionTargetDate?: Date | undefined;
    resolutionDateExplanation?: string | undefined;
    deviationFoundDate?: Date | undefined;
    descriptionEn?: string | undefined;
    descriptionRu?: string | undefined;
    descriptionKz?: string | undefined;
    discipline?: string | undefined;
    findingType?: FindingType;
    retirementDate?: Date;
    ffsPerformed?: FFSType;
    ffsResult?: FFSResultType;
    shutDownRequired?: ShutDownType;
    movedTo?: string | undefined;
    damageMechanisms?: DamageMechanismDto[] | undefined;
    value?: number;
    barrelsOfOilEquivalent?: number;
    tonsOfOilEquivalent?: number;
    currentState?: ApprovalState;
    currentFDMStatus?: FDMStatus;
    created?: Date;
    daysForApproval?: number | undefined;
    planApprovalDueDate?: Date | undefined;
    planApprovalDueSoon?: boolean;
}

export class GeneralTabFilterDto implements IGeneralTabFilterDto {
    reportType?: ReportType;
    search?: string | undefined;
    statuses?: ApprovalState[] | undefined;
    statusFilterMode?: StatusFilterMode;
    sortBy?: GeneralTabSortField;
    sortDirection?: SortDirection;
    columnFilters?: ColumnFilter[] | undefined;

    constructor(data?: IGeneralTabFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportType = _data["reportType"];
            this.search = _data["search"];
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(item);
            }
            this.statusFilterMode = _data["statusFilterMode"];
            this.sortBy = _data["sortBy"];
            this.sortDirection = _data["sortDirection"];
            if (Array.isArray(_data["columnFilters"])) {
                this.columnFilters = [] as any;
                for (let item of _data["columnFilters"])
                    this.columnFilters!.push(ColumnFilter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GeneralTabFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralTabFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportType"] = this.reportType;
        data["search"] = this.search;
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item);
        }
        data["statusFilterMode"] = this.statusFilterMode;
        data["sortBy"] = this.sortBy;
        data["sortDirection"] = this.sortDirection;
        if (Array.isArray(this.columnFilters)) {
            data["columnFilters"] = [];
            for (let item of this.columnFilters)
                data["columnFilters"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGeneralTabFilterDto {
    reportType?: ReportType;
    search?: string | undefined;
    statuses?: ApprovalState[] | undefined;
    statusFilterMode?: StatusFilterMode;
    sortBy?: GeneralTabSortField;
    sortDirection?: SortDirection;
    columnFilters?: ColumnFilter[] | undefined;
}

export class GeneralTabListItemDto implements IGeneralTabListItemDto {
    id?: string;
    uniqueId?: string | undefined;
    reportType?: ReportType;
    reportTitleEn?: string | undefined;
    facility?: string | undefined;
    equipment?: string | undefined;
    isSafeguard?: string | undefined;
    damageMechanisms?: string | undefined;
    discipline?: string | undefined;
    consequenceRanking?: string | undefined;
    status?: ApprovalState;
    step?: number | undefined;
    abcPrioritization?: string | undefined;
    riptSeriatimRank?: number | undefined;
    riskEvaluationScore?: string | undefined;
    createdOn?: Date | undefined;
    planApprovalDueDate?: Date | undefined;
    daysForApproval?: number | undefined;
    planApprovedDate?: Date | undefined;
    resolutionTargetDate?: Date | undefined;
    closedOn?: Date | undefined;
    waitingFor?: string | undefined;
    initiator?: string | undefined;
    owner?: string | undefined;
    taRequired?: boolean;
    ffsPerformed?: string | undefined;
    tlrReference?: string | undefined;
    tlrLink?: string | undefined;
    woReference?: string | undefined;
    woLink?: string | undefined;
    mocReference?: string | undefined;
    mocLink?: string | undefined;
    dewItReference?: string | undefined;
    dewItLink?: string | undefined;

    constructor(data?: IGeneralTabListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.uniqueId = _data["uniqueId"];
            this.reportType = _data["reportType"];
            this.reportTitleEn = _data["reportTitleEn"];
            this.facility = _data["facility"];
            this.equipment = _data["equipment"];
            this.isSafeguard = _data["isSafeguard"];
            this.damageMechanisms = _data["damageMechanisms"];
            this.discipline = _data["discipline"];
            this.consequenceRanking = _data["consequenceRanking"];
            this.status = _data["status"];
            this.step = _data["step"];
            this.abcPrioritization = _data["abcPrioritization"];
            this.riptSeriatimRank = _data["riptSeriatimRank"];
            this.riskEvaluationScore = _data["riskEvaluationScore"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.planApprovalDueDate = _data["planApprovalDueDate"] ? new Date(_data["planApprovalDueDate"].toString()) : undefined as any;
            this.daysForApproval = _data["daysForApproval"];
            this.planApprovedDate = _data["planApprovedDate"] ? new Date(_data["planApprovedDate"].toString()) : undefined as any;
            this.resolutionTargetDate = _data["resolutionTargetDate"] ? new Date(_data["resolutionTargetDate"].toString()) : undefined as any;
            this.closedOn = _data["closedOn"] ? new Date(_data["closedOn"].toString()) : undefined as any;
            this.waitingFor = _data["waitingFor"];
            this.initiator = _data["initiator"];
            this.owner = _data["owner"];
            this.taRequired = _data["taRequired"];
            this.ffsPerformed = _data["ffsPerformed"];
            this.tlrReference = _data["tlrReference"];
            this.tlrLink = _data["tlrLink"];
            this.woReference = _data["woReference"];
            this.woLink = _data["woLink"];
            this.mocReference = _data["mocReference"];
            this.mocLink = _data["mocLink"];
            this.dewItReference = _data["dewItReference"];
            this.dewItLink = _data["dewItLink"];
        }
    }

    static fromJS(data: any): GeneralTabListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralTabListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["uniqueId"] = this.uniqueId;
        data["reportType"] = this.reportType;
        data["reportTitleEn"] = this.reportTitleEn;
        data["facility"] = this.facility;
        data["equipment"] = this.equipment;
        data["isSafeguard"] = this.isSafeguard;
        data["damageMechanisms"] = this.damageMechanisms;
        data["discipline"] = this.discipline;
        data["consequenceRanking"] = this.consequenceRanking;
        data["status"] = this.status;
        data["step"] = this.step;
        data["abcPrioritization"] = this.abcPrioritization;
        data["riptSeriatimRank"] = this.riptSeriatimRank;
        data["riskEvaluationScore"] = this.riskEvaluationScore;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["planApprovalDueDate"] = this.planApprovalDueDate ? this.planApprovalDueDate.toISOString() : undefined as any;
        data["daysForApproval"] = this.daysForApproval;
        data["planApprovedDate"] = this.planApprovedDate ? this.planApprovedDate.toISOString() : undefined as any;
        data["resolutionTargetDate"] = this.resolutionTargetDate ? this.resolutionTargetDate.toISOString() : undefined as any;
        data["closedOn"] = this.closedOn ? this.closedOn.toISOString() : undefined as any;
        data["waitingFor"] = this.waitingFor;
        data["initiator"] = this.initiator;
        data["owner"] = this.owner;
        data["taRequired"] = this.taRequired;
        data["ffsPerformed"] = this.ffsPerformed;
        data["tlrReference"] = this.tlrReference;
        data["tlrLink"] = this.tlrLink;
        data["woReference"] = this.woReference;
        data["woLink"] = this.woLink;
        data["mocReference"] = this.mocReference;
        data["mocLink"] = this.mocLink;
        data["dewItReference"] = this.dewItReference;
        data["dewItLink"] = this.dewItLink;
        return data;
    }
}

export interface IGeneralTabListItemDto {
    id?: string;
    uniqueId?: string | undefined;
    reportType?: ReportType;
    reportTitleEn?: string | undefined;
    facility?: string | undefined;
    equipment?: string | undefined;
    isSafeguard?: string | undefined;
    damageMechanisms?: string | undefined;
    discipline?: string | undefined;
    consequenceRanking?: string | undefined;
    status?: ApprovalState;
    step?: number | undefined;
    abcPrioritization?: string | undefined;
    riptSeriatimRank?: number | undefined;
    riskEvaluationScore?: string | undefined;
    createdOn?: Date | undefined;
    planApprovalDueDate?: Date | undefined;
    daysForApproval?: number | undefined;
    planApprovedDate?: Date | undefined;
    resolutionTargetDate?: Date | undefined;
    closedOn?: Date | undefined;
    waitingFor?: string | undefined;
    initiator?: string | undefined;
    owner?: string | undefined;
    taRequired?: boolean;
    ffsPerformed?: string | undefined;
    tlrReference?: string | undefined;
    tlrLink?: string | undefined;
    woReference?: string | undefined;
    woLink?: string | undefined;
    mocReference?: string | undefined;
    mocLink?: string | undefined;
    dewItReference?: string | undefined;
    dewItLink?: string | undefined;
}

export class GeneralTabListItemDtoPagedResult implements IGeneralTabListItemDtoPagedResult {
    items?: GeneralTabListItemDto[] | undefined;
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    readonly totalPages?: number;
    readonly hasNextPage?: boolean;
    readonly hasPreviousPage?: boolean;

    constructor(data?: IGeneralTabListItemDtoPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GeneralTabListItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            (this as any).totalPages = _data["totalPages"];
            (this as any).hasNextPage = _data["hasNextPage"];
            (this as any).hasPreviousPage = _data["hasPreviousPage"];
        }
    }

    static fromJS(data: any): GeneralTabListItemDtoPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralTabListItemDtoPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasNextPage"] = this.hasNextPage;
        data["hasPreviousPage"] = this.hasPreviousPage;
        return data;
    }
}

export interface IGeneralTabListItemDtoPagedResult {
    items?: GeneralTabListItemDto[] | undefined;
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
}

export class GeneralTabSearchRequest implements IGeneralTabSearchRequest {
    pageNumber?: number;
    pageSize?: number;
    filter?: GeneralTabFilterDto;

    constructor(data?: IGeneralTabSearchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.filter = _data["filter"] ? GeneralTabFilterDto.fromJS(_data["filter"]) : undefined as any;
        }
    }

    static fromJS(data: any): GeneralTabSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralTabSearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["filter"] = this.filter ? this.filter.toJSON() : undefined as any;
        return data;
    }
}

export interface IGeneralTabSearchRequest {
    pageNumber?: number;
    pageSize?: number;
    filter?: GeneralTabFilterDto;
}

export enum GeneralTabSortField {
    CreatedOn = "CreatedOn",
    UniqueId = "UniqueId",
    ReportType = "ReportType",
    ReportTitleEn = "ReportTitleEn",
    Status = "Status",
    Discipline = "Discipline",
    WaitingFor = "WaitingFor",
    ResolutionTargetDate = "ResolutionTargetDate",
    Initiator = "Initiator",
    ClosedOn = "ClosedOn",
    Facility = "Facility",
    ABCPrioritization = "ABCPrioritization",
    ConsequenceRanking = "ConsequenceRanking",
    RiptSeriatimRank = "RiptSeriatimRank",
    PlanApprovedDate = "PlanApprovedDate",
    Equipment = "Equipment",
    IsSafeguard = "IsSafeguard",
    DamageMechanisms = "DamageMechanisms",
    Step = "Step",
    RiskEvaluationScore = "RiskEvaluationScore",
    PlanApprovalDueDate = "PlanApprovalDueDate",
    DaysUntilApprovalDeadline = "DaysUntilApprovalDeadline",
    Owner = "Owner",
    TARequired = "TARequired",
    FFSPerformed = "FFSPerformed",
    TlrReference = "TlrReference",
    WoReference = "WoReference",
    MocReference = "MocReference",
    DewItReference = "DewItReference",
}

export class GetPeopleDataByEmailResponseDto implements IGetPeopleDataByEmailResponseDto {
    description?: string | undefined;
    email?: string | undefined;
    preferredEmail?: string | undefined;
    sharedEmail?: string | undefined;

    constructor(data?: IGetPeopleDataByEmailResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.email = _data["email"];
            this.preferredEmail = _data["preferredEmail"];
            this.sharedEmail = _data["sharedEmail"];
        }
    }

    static fromJS(data: any): GetPeopleDataByEmailResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPeopleDataByEmailResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["email"] = this.email;
        data["preferredEmail"] = this.preferredEmail;
        data["sharedEmail"] = this.sharedEmail;
        return data;
    }
}

export interface IGetPeopleDataByEmailResponseDto {
    description?: string | undefined;
    email?: string | undefined;
    preferredEmail?: string | undefined;
    sharedEmail?: string | undefined;
}

export class ImportSynapseEquipmentsRequest implements IImportSynapseEquipmentsRequest {
    equipmentSource?: EquipmentSource;
    equipmentIds?: string[] | undefined;

    constructor(data?: IImportSynapseEquipmentsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.equipmentSource = _data["equipmentSource"];
            if (Array.isArray(_data["equipmentIds"])) {
                this.equipmentIds = [] as any;
                for (let item of _data["equipmentIds"])
                    this.equipmentIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ImportSynapseEquipmentsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImportSynapseEquipmentsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["equipmentSource"] = this.equipmentSource;
        if (Array.isArray(this.equipmentIds)) {
            data["equipmentIds"] = [];
            for (let item of this.equipmentIds)
                data["equipmentIds"].push(item);
        }
        return data;
    }
}

export interface IImportSynapseEquipmentsRequest {
    equipmentSource?: EquipmentSource;
    equipmentIds?: string[] | undefined;
}

export class OutOfServiceActionDto implements IOutOfServiceActionDto {
    approvalUserRole?: ApprovalUserRole;
    comment?: string | undefined;

    constructor(data?: IOutOfServiceActionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.approvalUserRole = _data["approvalUserRole"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): OutOfServiceActionDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutOfServiceActionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approvalUserRole"] = this.approvalUserRole;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IOutOfServiceActionDto {
    approvalUserRole?: ApprovalUserRole;
    comment?: string | undefined;
}

export class PeopleBriefDataByEmailDto implements IPeopleBriefDataByEmailDto {
    email?: string | undefined;
    preferredEmail?: string | undefined;
    sharedEmail?: string | undefined;
    supervisorEmail?: string | undefined;
    supervisorPreferredEmail?: string | undefined;
    supervisorSharedEmail?: string | undefined;
    bbEmail?: string | undefined;
    bbPreferredEmail?: string | undefined;
    bbSharedEmail?: string | undefined;

    constructor(data?: IPeopleBriefDataByEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.preferredEmail = _data["preferredEmail"];
            this.sharedEmail = _data["sharedEmail"];
            this.supervisorEmail = _data["supervisorEmail"];
            this.supervisorPreferredEmail = _data["supervisorPreferredEmail"];
            this.supervisorSharedEmail = _data["supervisorSharedEmail"];
            this.bbEmail = _data["bbEmail"];
            this.bbPreferredEmail = _data["bbPreferredEmail"];
            this.bbSharedEmail = _data["bbSharedEmail"];
        }
    }

    static fromJS(data: any): PeopleBriefDataByEmailDto {
        data = typeof data === 'object' ? data : {};
        let result = new PeopleBriefDataByEmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["preferredEmail"] = this.preferredEmail;
        data["sharedEmail"] = this.sharedEmail;
        data["supervisorEmail"] = this.supervisorEmail;
        data["supervisorPreferredEmail"] = this.supervisorPreferredEmail;
        data["supervisorSharedEmail"] = this.supervisorSharedEmail;
        data["bbEmail"] = this.bbEmail;
        data["bbPreferredEmail"] = this.bbPreferredEmail;
        data["bbSharedEmail"] = this.bbSharedEmail;
        return data;
    }
}

export interface IPeopleBriefDataByEmailDto {
    email?: string | undefined;
    preferredEmail?: string | undefined;
    sharedEmail?: string | undefined;
    supervisorEmail?: string | undefined;
    supervisorPreferredEmail?: string | undefined;
    supervisorSharedEmail?: string | undefined;
    bbEmail?: string | undefined;
    bbPreferredEmail?: string | undefined;
    bbSharedEmail?: string | undefined;
}

export class PeopleBriefDataDto implements IPeopleBriefDataDto {
    name?: string | undefined;
    phoneNumber!: string | undefined;
    title!: string | undefined;
    email!: string | undefined;
    preferredEmail?: string | undefined;
    sharedEmail?: string | undefined;

    constructor(data?: IPeopleBriefDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.phoneNumber = _data["phoneNumber"];
            this.title = _data["title"];
            this.email = _data["email"];
            this.preferredEmail = _data["preferredEmail"];
            this.sharedEmail = _data["sharedEmail"];
        }
    }

    static fromJS(data: any): PeopleBriefDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new PeopleBriefDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["title"] = this.title;
        data["email"] = this.email;
        data["preferredEmail"] = this.preferredEmail;
        data["sharedEmail"] = this.sharedEmail;
        return data;
    }
}

export interface IPeopleBriefDataDto {
    name?: string | undefined;
    phoneNumber: string | undefined;
    title: string | undefined;
    email: string | undefined;
    preferredEmail?: string | undefined;
    sharedEmail?: string | undefined;
}

export enum PercentOverdue {
    LessThan10 = "LessThan10",
    TenToLessThan20 = "TenToLessThan20",
    TwentyToLessThan30 = "TwentyToLessThan30",
    ThirtyToLessThan40 = "ThirtyToLessThan40",
    Forty = "Forty",
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class ReactivateActionItemRequestDto implements IReactivateActionItemRequestDto {
    comment!: string | undefined;

    constructor(data?: IReactivateActionItemRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): ReactivateActionItemRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReactivateActionItemRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment;
        return data;
    }
}

export interface IReactivateActionItemRequestDto {
    comment: string | undefined;
}

export enum ReferenceType {
    None = "None",
    Ewr = "Ewr",
    WorkOrder = "WorkOrder",
    Moc = "Moc",
}

export enum ReportType {
    IntegrityThreat = "IntegrityThreat",
    ReliabilityThreat = "ReliabilityThreat",
    IntegrityDeficiency = "IntegrityDeficiency",
    ReliabilityDeficiency = "ReliabilityDeficiency",
    TaskDeferral = "TaskDeferral",
    AnomalyReport = "AnomalyReport",
}

export class ResolutionAndMitigationPlanDto implements IResolutionAndMitigationPlanDto {
    id?: number;
    mitigationPlanEn?: string | undefined;
    mitigationPlanRu?: string | undefined;
    mitigationPlanKz?: string | undefined;
    resolutionPlanEn?: string | undefined;
    resolutionPlanRu?: string | undefined;
    resolutionPlanKz?: string | undefined;
    validatonVerificationComment?: string | undefined;
    generalTabId?: string;
    actionItems?: ActionItemDto[] | undefined;

    constructor(data?: IResolutionAndMitigationPlanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mitigationPlanEn = _data["mitigationPlanEn"];
            this.mitigationPlanRu = _data["mitigationPlanRu"];
            this.mitigationPlanKz = _data["mitigationPlanKz"];
            this.resolutionPlanEn = _data["resolutionPlanEn"];
            this.resolutionPlanRu = _data["resolutionPlanRu"];
            this.resolutionPlanKz = _data["resolutionPlanKz"];
            this.validatonVerificationComment = _data["validatonVerificationComment"];
            this.generalTabId = _data["generalTabId"];
            if (Array.isArray(_data["actionItems"])) {
                this.actionItems = [] as any;
                for (let item of _data["actionItems"])
                    this.actionItems!.push(ActionItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResolutionAndMitigationPlanDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResolutionAndMitigationPlanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mitigationPlanEn"] = this.mitigationPlanEn;
        data["mitigationPlanRu"] = this.mitigationPlanRu;
        data["mitigationPlanKz"] = this.mitigationPlanKz;
        data["resolutionPlanEn"] = this.resolutionPlanEn;
        data["resolutionPlanRu"] = this.resolutionPlanRu;
        data["resolutionPlanKz"] = this.resolutionPlanKz;
        data["validatonVerificationComment"] = this.validatonVerificationComment;
        data["generalTabId"] = this.generalTabId;
        if (Array.isArray(this.actionItems)) {
            data["actionItems"] = [];
            for (let item of this.actionItems)
                data["actionItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResolutionAndMitigationPlanDto {
    id?: number;
    mitigationPlanEn?: string | undefined;
    mitigationPlanRu?: string | undefined;
    mitigationPlanKz?: string | undefined;
    resolutionPlanEn?: string | undefined;
    resolutionPlanRu?: string | undefined;
    resolutionPlanKz?: string | undefined;
    validatonVerificationComment?: string | undefined;
    generalTabId?: string;
    actionItems?: ActionItemDto[] | undefined;
}

export class RiptTabDto implements IRiptTabDto {
    id?: number;
    riptUrl?: string | undefined;
    criteriaDrivingScore?: string | undefined;
    abcPrioritization?: string | undefined;
    seriatimRank?: number | undefined;
    initialInvestment?: number | undefined;
    hseRiskEfficiency?: number | undefined;
    needRiskAnalysis?: boolean | undefined;
    likelyScenario?: string | undefined;
    likelyConsequence?: string | undefined;
    riskManRiskScore?: string | undefined;
    riskManCategory?: string | undefined;
    rorPercent?: number | undefined;
    dpi?: number | undefined;
    assetRisk?: string | undefined;
    generalTabId?: string;
    riskConsiderationId?: number | undefined;
    riskConsideration?: RiskConsiderationDto;
    technicalAssesmentId?: number | undefined;
    technicalAssesment?: TechnicalAssesmentDto;

    constructor(data?: IRiptTabDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.riptUrl = _data["riptUrl"];
            this.criteriaDrivingScore = _data["criteriaDrivingScore"];
            this.abcPrioritization = _data["abcPrioritization"];
            this.seriatimRank = _data["seriatimRank"];
            this.initialInvestment = _data["initialInvestment"];
            this.hseRiskEfficiency = _data["hseRiskEfficiency"];
            this.needRiskAnalysis = _data["needRiskAnalysis"];
            this.likelyScenario = _data["likelyScenario"];
            this.likelyConsequence = _data["likelyConsequence"];
            this.riskManRiskScore = _data["riskManRiskScore"];
            this.riskManCategory = _data["riskManCategory"];
            this.rorPercent = _data["rorPercent"];
            this.dpi = _data["dpi"];
            this.assetRisk = _data["assetRisk"];
            this.generalTabId = _data["generalTabId"];
            this.riskConsiderationId = _data["riskConsiderationId"];
            this.riskConsideration = _data["riskConsideration"] ? RiskConsiderationDto.fromJS(_data["riskConsideration"]) : undefined as any;
            this.technicalAssesmentId = _data["technicalAssesmentId"];
            this.technicalAssesment = _data["technicalAssesment"] ? TechnicalAssesmentDto.fromJS(_data["technicalAssesment"]) : undefined as any;
        }
    }

    static fromJS(data: any): RiptTabDto {
        data = typeof data === 'object' ? data : {};
        let result = new RiptTabDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["riptUrl"] = this.riptUrl;
        data["criteriaDrivingScore"] = this.criteriaDrivingScore;
        data["abcPrioritization"] = this.abcPrioritization;
        data["seriatimRank"] = this.seriatimRank;
        data["initialInvestment"] = this.initialInvestment;
        data["hseRiskEfficiency"] = this.hseRiskEfficiency;
        data["needRiskAnalysis"] = this.needRiskAnalysis;
        data["likelyScenario"] = this.likelyScenario;
        data["likelyConsequence"] = this.likelyConsequence;
        data["riskManRiskScore"] = this.riskManRiskScore;
        data["riskManCategory"] = this.riskManCategory;
        data["rorPercent"] = this.rorPercent;
        data["dpi"] = this.dpi;
        data["assetRisk"] = this.assetRisk;
        data["generalTabId"] = this.generalTabId;
        data["riskConsiderationId"] = this.riskConsiderationId;
        data["riskConsideration"] = this.riskConsideration ? this.riskConsideration.toJSON() : undefined as any;
        data["technicalAssesmentId"] = this.technicalAssesmentId;
        data["technicalAssesment"] = this.technicalAssesment ? this.technicalAssesment.toJSON() : undefined as any;
        return data;
    }
}

export interface IRiptTabDto {
    id?: number;
    riptUrl?: string | undefined;
    criteriaDrivingScore?: string | undefined;
    abcPrioritization?: string | undefined;
    seriatimRank?: number | undefined;
    initialInvestment?: number | undefined;
    hseRiskEfficiency?: number | undefined;
    needRiskAnalysis?: boolean | undefined;
    likelyScenario?: string | undefined;
    likelyConsequence?: string | undefined;
    riskManRiskScore?: string | undefined;
    riskManCategory?: string | undefined;
    rorPercent?: number | undefined;
    dpi?: number | undefined;
    assetRisk?: string | undefined;
    generalTabId?: string;
    riskConsiderationId?: number | undefined;
    riskConsideration?: RiskConsiderationDto;
    technicalAssesmentId?: number | undefined;
    technicalAssesment?: TechnicalAssesmentDto;
}

export class RiskConsiderationDto implements IRiskConsiderationDto {
    id?: number | undefined;
    roKConsiderationsEN?: string | undefined;
    roKConsiderationsRU?: string | undefined;
    roKConsiderationsKZ?: string | undefined;

    constructor(data?: IRiskConsiderationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.roKConsiderationsEN = _data["roKConsiderationsEN"];
            this.roKConsiderationsRU = _data["roKConsiderationsRU"];
            this.roKConsiderationsKZ = _data["roKConsiderationsKZ"];
        }
    }

    static fromJS(data: any): RiskConsiderationDto {
        data = typeof data === 'object' ? data : {};
        let result = new RiskConsiderationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["roKConsiderationsEN"] = this.roKConsiderationsEN;
        data["roKConsiderationsRU"] = this.roKConsiderationsRU;
        data["roKConsiderationsKZ"] = this.roKConsiderationsKZ;
        return data;
    }
}

export interface IRiskConsiderationDto {
    id?: number | undefined;
    roKConsiderationsEN?: string | undefined;
    roKConsiderationsRU?: string | undefined;
    roKConsiderationsKZ?: string | undefined;
}

export class RiskEvaluationDto implements IRiskEvaluationDto {
    id?: number;
    generalTabId?: string | undefined;
    category?: RiskEvualationCategory;
    consequence?: number | undefined;
    likelihood?: number | undefined;

    constructor(data?: IRiskEvaluationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.generalTabId = _data["generalTabId"];
            this.category = _data["category"];
            this.consequence = _data["consequence"];
            this.likelihood = _data["likelihood"];
        }
    }

    static fromJS(data: any): RiskEvaluationDto {
        data = typeof data === 'object' ? data : {};
        let result = new RiskEvaluationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["generalTabId"] = this.generalTabId;
        data["category"] = this.category;
        data["consequence"] = this.consequence;
        data["likelihood"] = this.likelihood;
        return data;
    }
}

export interface IRiskEvaluationDto {
    id?: number;
    generalTabId?: string | undefined;
    category?: RiskEvualationCategory;
    consequence?: number | undefined;
    likelihood?: number | undefined;
}

export enum RiskEvualationCategory {
    HealthAndSafety = "HealthAndSafety",
    Environmental = "Environmental",
    Reputation = "Reputation",
    Asset = "Asset",
}

export enum ShutDownType {
    Yes = "Yes",
    No = "No",
    TBD = "TBD",
}

export enum SortDirection {
    Asc = "Asc",
    Desc = "Desc",
}

export enum StatusFilterMode {
    Include = "Include",
    Exclude = "Exclude",
}

export enum TaScopeEnum {
    TA = "TA",
    NonTA = "NonTA",
}

export enum TaskFrequency {
    GreaterOrEqual5Years = "GreaterOrEqual5Years",
    ThreeToLessThanFiveYears = "ThreeToLessThanFiveYears",
    OneToLessThanThreeYears = "OneToLessThanThreeYears",
    LessThanOneYear = "LessThanOneYear",
}

export class TechnicalAssesmentDto implements ITechnicalAssesmentDto {
    id?: number;
    operatingConditionDescriptionEN?: string | undefined;
    operatingConditionDescriptionRU?: string | undefined;
    operatingConditionDescriptionKZ?: string | undefined;
    technicalAssesmentDescriptionEN?: string | undefined;
    technicalAssesmentDescriptionRU?: string | undefined;
    technicalAssesmentDescriptionKZ?: string | undefined;

    constructor(data?: ITechnicalAssesmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.operatingConditionDescriptionEN = _data["operatingConditionDescriptionEN"];
            this.operatingConditionDescriptionRU = _data["operatingConditionDescriptionRU"];
            this.operatingConditionDescriptionKZ = _data["operatingConditionDescriptionKZ"];
            this.technicalAssesmentDescriptionEN = _data["technicalAssesmentDescriptionEN"];
            this.technicalAssesmentDescriptionRU = _data["technicalAssesmentDescriptionRU"];
            this.technicalAssesmentDescriptionKZ = _data["technicalAssesmentDescriptionKZ"];
        }
    }

    static fromJS(data: any): TechnicalAssesmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new TechnicalAssesmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["operatingConditionDescriptionEN"] = this.operatingConditionDescriptionEN;
        data["operatingConditionDescriptionRU"] = this.operatingConditionDescriptionRU;
        data["operatingConditionDescriptionKZ"] = this.operatingConditionDescriptionKZ;
        data["technicalAssesmentDescriptionEN"] = this.technicalAssesmentDescriptionEN;
        data["technicalAssesmentDescriptionRU"] = this.technicalAssesmentDescriptionRU;
        data["technicalAssesmentDescriptionKZ"] = this.technicalAssesmentDescriptionKZ;
        return data;
    }
}

export interface ITechnicalAssesmentDto {
    id?: number;
    operatingConditionDescriptionEN?: string | undefined;
    operatingConditionDescriptionRU?: string | undefined;
    operatingConditionDescriptionKZ?: string | undefined;
    technicalAssesmentDescriptionEN?: string | undefined;
    technicalAssesmentDescriptionRU?: string | undefined;
    technicalAssesmentDescriptionKZ?: string | undefined;
}

export class TimelineItemDto implements ITimelineItemDto {
    type?: TimelineItemType;
    title?: string | undefined;
    previewText?: string | undefined;
    author?: string | undefined;
    created?: Date;
    recipients?: string[] | undefined;
    state?: string | undefined;
    noteId?: number | undefined;
    generalTabId?: string;
    attachments?: AttachmentDto[] | undefined;
    isProcessed?: boolean | undefined;

    constructor(data?: ITimelineItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.title = _data["title"];
            this.previewText = _data["previewText"];
            this.author = _data["author"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            if (Array.isArray(_data["recipients"])) {
                this.recipients = [] as any;
                for (let item of _data["recipients"])
                    this.recipients!.push(item);
            }
            this.state = _data["state"];
            this.noteId = _data["noteId"];
            this.generalTabId = _data["generalTabId"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDto.fromJS(item));
            }
            this.isProcessed = _data["isProcessed"];
        }
    }

    static fromJS(data: any): TimelineItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimelineItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["previewText"] = this.previewText;
        data["author"] = this.author;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        if (Array.isArray(this.recipients)) {
            data["recipients"] = [];
            for (let item of this.recipients)
                data["recipients"].push(item);
        }
        data["state"] = this.state;
        data["noteId"] = this.noteId;
        data["generalTabId"] = this.generalTabId;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        data["isProcessed"] = this.isProcessed;
        return data;
    }
}

export interface ITimelineItemDto {
    type?: TimelineItemType;
    title?: string | undefined;
    previewText?: string | undefined;
    author?: string | undefined;
    created?: Date;
    recipients?: string[] | undefined;
    state?: string | undefined;
    noteId?: number | undefined;
    generalTabId?: string;
    attachments?: AttachmentDto[] | undefined;
    isProcessed?: boolean | undefined;
}

export enum TimelineItemType {
    Notification = "Notification",
    Note = "Note",
    StatusChangeComment = "StatusChangeComment",
}

export class TlrEntryDto implements ITlrEntryDto {
    id?: string;
    generalTabId?: string;
    tag?: string | undefined;
    tlrType?: TlrTypeEnum;
    taScope?: TaScopeEnum;
    equipmentProcessService?: EquipmentProcessServiceEnum;
    dateTlrInstalled?: Date | undefined;
    recommendedPermanentRepairDate?: Date | undefined;
    created?: Date;
    updated?: Date;

    constructor(data?: ITlrEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.generalTabId = _data["generalTabId"];
            this.tag = _data["tag"];
            this.tlrType = _data["tlrType"];
            this.taScope = _data["taScope"];
            this.equipmentProcessService = _data["equipmentProcessService"];
            this.dateTlrInstalled = _data["dateTlrInstalled"] ? new Date(_data["dateTlrInstalled"].toString()) : undefined as any;
            this.recommendedPermanentRepairDate = _data["recommendedPermanentRepairDate"] ? new Date(_data["recommendedPermanentRepairDate"].toString()) : undefined as any;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): TlrEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new TlrEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["generalTabId"] = this.generalTabId;
        data["tag"] = this.tag;
        data["tlrType"] = this.tlrType;
        data["taScope"] = this.taScope;
        data["equipmentProcessService"] = this.equipmentProcessService;
        data["dateTlrInstalled"] = this.dateTlrInstalled ? this.dateTlrInstalled.toISOString() : undefined as any;
        data["recommendedPermanentRepairDate"] = this.recommendedPermanentRepairDate ? this.recommendedPermanentRepairDate.toISOString() : undefined as any;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        return data;
    }
}

export interface ITlrEntryDto {
    id?: string;
    generalTabId?: string;
    tag?: string | undefined;
    tlrType?: TlrTypeEnum;
    taScope?: TaScopeEnum;
    equipmentProcessService?: EquipmentProcessServiceEnum;
    dateTlrInstalled?: Date | undefined;
    recommendedPermanentRepairDate?: Date | undefined;
    created?: Date;
    updated?: Date;
}

export enum TlrTypeEnum {
    CompositeWrapRepair = "CompositeWrapRepair",
    EngineeredEnclosure = "EngineeredEnclosure",
    WeldedPatchEnclosureSleeve = "WeldedPatchEnclosureSleeve",
    WireWrap = "WireWrap",
    ValvePackingGlandRepair = "ValvePackingGlandRepair",
    Crimping = "Crimping",
    Injection = "Injection",
}

export class UpdateDistributionListDto implements IUpdateDistributionListDto {
    commonEmailsTo?: string | undefined;
    commonEmailsCc?: string | undefined;
    turnaroundEmailsTo?: string | undefined;

    constructor(data?: IUpdateDistributionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.commonEmailsTo = _data["commonEmailsTo"];
            this.commonEmailsCc = _data["commonEmailsCc"];
            this.turnaroundEmailsTo = _data["turnaroundEmailsTo"];
        }
    }

    static fromJS(data: any): UpdateDistributionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDistributionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commonEmailsTo"] = this.commonEmailsTo;
        data["commonEmailsCc"] = this.commonEmailsCc;
        data["turnaroundEmailsTo"] = this.turnaroundEmailsTo;
        return data;
    }
}

export interface IUpdateDistributionListDto {
    commonEmailsTo?: string | undefined;
    commonEmailsCc?: string | undefined;
    turnaroundEmailsTo?: string | undefined;
}

export class UpdateRequest implements IUpdateRequest {
    type?: ReferenceType;
    link?: string | undefined;
    description?: string | undefined;
    status?: string | undefined;

    constructor(data?: IUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.link = _data["link"];
            this.description = _data["description"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["link"] = this.link;
        data["description"] = this.description;
        data["status"] = this.status;
        return data;
    }
}

export interface IUpdateRequest {
    type?: ReferenceType;
    link?: string | undefined;
    description?: string | undefined;
    status?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}